<template>
  <div class="load-profile-list" :class="{ 'is-loading': showLoadingSpinner }">
    <div
      class="progress-icon dark-color center"
      v-if="showLoadingSpinner"
    ></div>

    <div class="pt-45" v-show="!showLoadingSpinner">
      <div
        class="round-button-wrapper"
        :class="{ clicked: this.isAddOptionsVisible }"
      >
        <div
          v-if="database.access_level != 'read'"
          class="round-button"
          ref="plusButton"
          v-b-tooltip.hover
          title="Lastgang hinzufügen"
          @click="togglePlusBtn()"
        >
          <span class="plus"> + </span>
        </div>
        <div class="plus-btn-options" v-show="isAddOptionsVisible">
          <div class="option small" @click="showSlpProfile">
            <img class="icon" src="../assets/img/slp-chart.png" />
            <h2>Profil</h2>
            <p>Lastgang erstellen</p>
          </div>
          <div class="option small" @click="callUpload()">
            <img class="icon" src="../assets/img/file.png" />
            <h2>Datei</h2>
            <p>Lastgang hochladen</p>
          </div>
        </div>
      </div>

      <div class="action-top-bar">
        <div class="action-top-bar-left">
          <div class="menu3-bar" v-if="isZoomVisible">
            <ul class="list-item">
              <li class="item filter-option">
                <div class="key-filter">
                  <!-- Add new filter button -->
                  <div class="filter" v-click-outside="hideAddFilter">
                    <span class="filter-icon" @click="showAddFilter"></span>
                    <br />
                    <!-- Add new filter drop down-->
                    <div
                      class="filter dropdown add"
                      v-if="activeFilter != null && isAddFilterVisible"
                    >
                      <h2>Neuer Filter</h2>
                      <generalDropdown className="filter-dropdown">
                        <template v-slot:selectFilter>
                          <span class="line-clamp"
                            >{{ activeFilter.caption }}
                          </span>
                        </template>
                        <template v-slot:optionData>
                          <b-dropdown-item
                            v-for="item in dataSchema"
                            :key="item.label"
                            @click="addFilterCaption(item.name)"
                          >
                            {{ formatLabel(item.label) }}
                          </b-dropdown-item>
                        </template>
                      </generalDropdown>
                      <generalDropdown className="filter-dropdown">
                        <template v-slot:selectFilter>
                          <span class="line-clamp"
                            >{{ activeFilter.opperandLabel }}
                          </span>
                        </template>
                        <template v-slot:optionData>
                          <b-dropdown-item
                            v-for="operator in getOperatorOption"
                            :key="operator.label"
                            @click="
                              addFilterOpperand(
                                operator.opperand,
                                operator.label
                              )
                            "
                          >
                            {{ operator.label }}
                          </b-dropdown-item>
                        </template>
                      </generalDropdown>
                      <input
                        name="filter"
                        v-if="checkFilterInput(activeFilter.type) == 'text'"
                        v-model="activeFilter.value"
                        :type="activeFilter.type"
                      />
                      <input
                        name="filter"
                        v-if="checkFilterInput(activeFilter.type) == 'datetime'"
                        v-model="activeFilter.value"
                        type="datetime-local"
                      />
                      <generalDropdown
                        className="filter-dropdown"
                        v-if="
                          checkFilterInput(activeFilter.type) === 'selectBox'
                        "
                      >
                        <template v-slot:selectFilter>
                          <span class="line-clamp"
                            >{{ activeFilter.value }}
                          </span>
                        </template>
                        <template v-slot:optionData>
                          <b-dropdown-item
                            v-for="optionValue in activeFilter.options"
                            :key="optionValue"
                            @click="addFilterValue(optionValue)"
                          >
                            {{ optionValue }}
                          </b-dropdown-item>
                        </template>
                      </generalDropdown>
                      <hr />
                    </div>
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="search" v-bind:class="{ active: searchActive }">
                  <span class="search-icon" @click="toggleSearch"></span>
                  <input ref="search" name="search" v-model="search" />
                </div>
              </li>
              <li
                v-for="(value, key, index) in filterOptions"
                :key="index"
                class="item"
                @click="setFilter(key)"
                :class="{ active: filter == key }"
              >
                <a>{{ value.caption }}</a>
              </li>
              <!-- time filter -->
              <li class="item more" v-show="true">
                <div class="dropdown">
                  <generalDropdown :isCaretVisible="false">
                    <template v-slot:iconContainer>
                      <a class="link">
                        <img
                          class="clock-icon"
                          src="../assets/img/clock-icon.svg"
                          alt="clock icon"
                        /> </a
                    ></template>
                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="time in timeFilterOptions"
                        :key="time.value"
                        :class="{ selected: time?.selected }"
                        @click="setTimeFilter(time)"
                      >
                        {{ time.caption }}
                      </b-dropdown-item>
                    </template>
                  </generalDropdown>
                </div>
              </li>
              <!-- end time filter -->
            </ul>
          </div>
        </div>
        <div class="action-top-bar-right">
          <div class="view-settings">
            <div
              class="settings-button-wrapper"
              v-show="
                !htmlViewerModal.isHtmlViewerVisible && !isAddOptionsVisible
              "
            >
              <div
                class="round-button refresh"
                :class="{ rotation: isRefreshing }"
                @click="!isRefreshing && refreshItems()"
                v-b-tooltip.hover
                title="Aktualisieren"
              >
                <img src="../assets/img/refresh.svg" />
              </div>
              <div
                class="round-button settings"
                @click="showSettings()"
                v-b-tooltip.hover
                title="Einstellungen"
              >
                <img src="../assets/img/cog.svg" />
              </div>
            </div>
            <div class="list-view-btn-wrap" v-if="isZoomVisible">
              <div class="zoom" v-if="view == 'icon'">
                <input
                  class="slider"
                  type="range"
                  min="50"
                  max="120"
                  step="5"
                  v-model="zoom"
                />
              </div>
              <div
                class="list-view-icon"
                :class="{ active: view == 'list' }"
                @click="toggleView('list')"
                v-b-tooltip.hover
                title="Listenansicht"
              >
                <img
                  src="../assets/img/list icon.svg"
                  class="btn"
                  alt="list view"
                />
              </div>
              <div
                class="list-view-icon"
                :class="{ active: view == 'icon' }"
                @click="toggleView('icon')"
                v-b-tooltip.hover
                title="Rasteransicht"
              >
                <img
                  src="../assets/img/icons-icon.svg"
                  class="btn"
                  alt="icon view"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filter list -->
      <div class="filter-item-wrapper">
        <div class="filter-item" v-for="filter in filters" :key="filter.id">
          <span>{{ filter.caption }}</span>
          <i
            title="Bearbeiten"
            class="fas fa-caret-down"
            @click="showEditFilter(filter)"
          ></i>
          <i
            title="Löschen"
            class="fas fa-trash"
            @click="removeFilter(filter.id)"
          ></i>
          <!-- Edit filter drop down-->
          <div
            v-if="
              activeFilter != null &&
              isEditFilterVisible &&
              activeFilter.id == filter.id
            "
          >
            <div class="filter dropdown edit" v-click-outside="hideEditFilter">
              <generalDropdown className="filter-dropdown">
                <template v-slot:selectFilter>
                  <span class="line-clamp"
                    >{{ activeFilter.opperandLabel }}
                  </span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="operator in getOperatorOption"
                    :key="operator.label"
                    @click="
                      addFilterOpperand(operator.opperand, operator.label)
                    "
                  >
                    {{ operator.label }}
                  </b-dropdown-item>
                </template>
              </generalDropdown>
              <input
                name="filter"
                v-if="checkFilterInput(activeFilter.type) == 'text'"
                v-model="activeFilter.value"
                :type="activeFilter.type"
              />
              <input
                name="filter"
                v-if="checkFilterInput(activeFilter.type) == 'datetime'"
                v-model="activeFilter.value"
                type="datetime-local"
              />
              <generalDropdown
                className="filter-dropdown"
                v-if="checkFilterInput(activeFilter.type) === 'selectBox'"
              >
                <template v-slot:selectFilter>
                  <span class="line-clamp">{{ activeFilter.value }} </span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="optionValue in activeFilter.options"
                    :key="optionValue"
                    @click="addFilterValue(optionValue)"
                  >
                    {{ optionValue }}
                  </b-dropdown-item>
                </template>
              </generalDropdown>
            </div>
          </div>
        </div>
      </div>

      <div
        class="group-actions"
        v-if="showGroupAction && !htmlViewerModal.isHtmlViewerVisible"
      >
        <div class="inner">
          <p>
            <span class="selected-items">{{ selectedElements.length }}</span>
            <span class="selected-items-label">Ausgewählte Elemente</span>
          </p>
          <ul class="toolbar">
            <li
              class="item share"
              @click="shareselectedItems()"
              v-show="isSeriesSelected"
              v-b-tooltip.hover
              title="Teilen"
            >
              <a class="link">share</a>
            </li>
            <!-- Group-duplicate currently disabled -->
            <!--
            <li
              v-if="database.access_level != 'read'"
              title="Duplizieren"
              class="item duplicate"
              v-on:click="duplicateElement(item)"
            >
            <a class="link">duplicate</a>
          </li> -->
            <li
              class="item download"
              @click="exportSelectedLoads()"
              v-show="isSeriesSelected"
              v-b-tooltip.hover
              title="Herunterladen"
            >
              <a class="link">download</a>
            </li>
            <li
              v-if="database.access_level !== 'read' && !database.add_only"
              class="item delete"
              @click="
                selectedElements.length > 100
                  ? showMaxFilesReached(100, 'Elemente')
                  : removeSelectedElements()
              "
              v-b-tooltip.hover
              title="Löschen"
            >
              <a class="link">delete</a>
            </li>
            <li
              class="item more-icon-wrapper"
              v-if="
                appSettings.showMoreGroupFunctions && selectedSeriesCount > 0
              "
            >
              <div class="dropdown">
                <generalDropdown :isCaretVisible="false" className="">
                  <template v-slot:iconContainer>
                    <img
                      src="../assets/img/more-icon.svg"
                      class="more-icon"
                      alt="more"
                    />
                  </template>
                  <template v-slot:optionData>
                    <template v-for="action in listActionDropdownOptions">
                      <b-dropdown-item
                        :key="action.name"
                        @[action[`eventName`]]="action.eventHandler()"
                        v-if="action.isShowAction()"
                        ><i
                          v-if="action.icon == 'plusIcon'"
                          class="far fa-plus-square"
                        ></i
                        >{{ action.name }}</b-dropdown-item
                      >
                    </template>
                  </template>
                </generalDropdown>
                <div
                  class="dropdown"
                  :key="action.name"
                  v-if="showActionsDropdown"
                >
                  <div
                    class="toggle-list-wrapper toggle-up toggle-right"
                    :style="{ top: actionsDropdownHeight + 'px' }"
                    v-click-outside="closeDropdowns"
                    @mouseleave="toggleActionsDropdown()"
                  >
                    <!-- List all actions -->
                    <div
                      class="item"
                      v-for="action in actionList"
                      :key="action.id"
                      @click="runAction(action.id)"
                      v-show="selectedSeriesCount == 1"
                    >
                      {{ action.name }}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div
          v-show="selectedElements.length > 0 && !isAddOptionsVisible"
          class="select-all-wrapper"
        >
          <button
            class="btn-select-all"
            :disabled="allItemsSelected"
            @click="selectAll()"
          >
            Alle auswählen
          </button>
          <button class="btn-select-all" @click="unselectAll()">
            Alle abwählen
          </button>
        </div>
      </div>
      <modal-box
        class="modal-window"
        v-bind:title="modalBox.title"
        v-bind:message="modalBox.msg"
        v-bind:buttonCaption="modalBox.btnCaption"
        v-if="isModalVisible || modalBox.showModalBox"
        @close="hideModalBox"
      />
      <modal-share
        class="modal-window"
        v-if="shareSetting.isShareModalVisible"
        :artefact="this.shareSetting.artefact"
        :description="this.shareSetting.description"
        :attachment="this.shareSetting.attachment"
        @close="closeModal"
      />
      <report-viewer
        class="modal-window"
        v-if="reportViewer.isReportViewerVisible"
        :title="reportViewer.title"
        :json="reportViewer.json"
        :buttonCaption="reportViewer.btnCaption"
        @close="hideReportViewer"
      />
      <changeUnitModal
        v-if="isChangeUnitModalOpen"
        @closeUnitModal="closeUnitModal"
        @reInterpretUnit="addUnitToLoad"
        @convertLoad="convertLoad"
        :isLoading="false"
      />
      <div
        class="no-data"
        v-show="noData && !uploadActive && !isLoading && itemsToProcess < 1"
      >
        <div class="options">
          <div
            class="option left-option"
            @click="showApiOptions('left')"
            :class="{
              'single-option':
                this.appSettings.loadProfileList.showSingleOption,
            }"
          >
            <img
              class="icon"
              :src="getImgUrl(appSettings.loadProfileList.leftImgSrc)"
            />
            <h2>{{ appSettings.loadProfileList.leftTitle }}</h2>
            <p>
              {{ appSettings.loadProfileList.leftText }}
            </p>
          </div>
          <div
            class="option right-option"
            @click="showApiOptions('right')"
            v-if="!this.appSettings.loadProfileList.showSingleOption"
          >
            <img
              class="icon"
              :src="getImgUrl(appSettings.loadProfileList.rightImgSrc)"
            />
            <h2>{{ appSettings.loadProfileList.rightTitle }}</h2>
            <p>
              {{ appSettings.loadProfileList.rightText }}
            </p>
          </div>
        </div>
      </div>
      <SlpProfile
        class="modal-window"
        :database="database"
        v-if="isSlpProfileVisible"
        @close="closeSlpProfile"
        @slpPreview="createPreviewItem"
      />
      <Weather
        class="modal-window"
        v-show="isWeatherVisible"
        @close="(profile) => this.closeWeather(profile)"
      />
      <!-- Preview List view -->
      <!-- :class="{ 'mt-5': filters.length }" -->
      <div
        class="header"
        v-if="
          customFilter.length &&
          filter !== 'reports' &&
          view === 'list' &&
          !uploadActive &&
          !isAddOptionsVisible
        "
      >
        <div style="width: 4%"></div>
        <div style="width: 26%"></div>
        <div style="width: 10%">Einheit</div>
        <div style="width: 15%">Von - bis</div>
        <div style="width: 15%">Summe</div>
        <div style="width: 15%">Gesamtmenge</div>
        <div style="width: 15%">Erstellt am</div>
      </div>
      <div
        @scroll.passive="onLoadProfileListScrolled"
        ref="loadlist"
        class="customdropzone"
        :class="{
          'list-view': view === 'list',
          'customdropzone-spacing-to-top':
            filter === 'reports' && filters.length > 0,
        }"
        v-show="!uploadActive && !isLoading"
      >
        <!-- If no content available for the filter -->
        <div
          v-show="
            this.filter != 'unset' && this.filteredItems.length < 1 && !noData
          "
          dz-preview-wrapper
          class="dz-no-content-message"
        >
          <p>
            Für den ausgewählten Filter konnten keine Daten gefunden werden.
          </p>
        </div>
        <!-- preview element icon view -->
        <!-- :class="{ 'filter-space': filters.length >= 1 }" -->
        <div v-show="view === 'icon' && !showLoadingSpinner" class="icon-view">
          <div
            v-for="(item, indx) in customFilter"
            :key="item.id"
            :index="parseInt(indx) + 1"
            :ref="item.id"
            class="dz-preview dz-file-preview"
            v-bind:class="[{ checked: isSelectedItem(item.id) }, view]"
            v-bind:style="{ zoom: getZoom() }"
            @mouseenter="elOnHoverIdx = item.id"
            @mouseleave="hideActionDropdown()"
          >
            <div dz-preview-wrapper class="dz-preview-wrapper">
              <!-- Image / Chart / Thumbnail -->
              <div class="dz-image">
                <div class="data-dz-thumbnail-bg">
                  <div
                    class="status-icon"
                    v-if="
                      item.status == 'uploading' || item.status == 'processing'
                    "
                  >
                    <div class="dot-flashing"></div>
                  </div>
                </div>

                <!-- status -->
                <div v-if="item.ts_type == 'file'">
                  <div class="status-img" v-if="item.status == 'failed'">
                    <img src="../assets/img/status_icon_failed.svg" />
                  </div>
                  <div class="status-img" v-if="item.status == 'success'">
                    <img src="../assets/img/status_icon_success.svg" />
                  </div>
                </div>

                <!-- chart -->
                <Chart
                  v-if="item.hasOwnProperty('data')"
                  v-show="item.ts_type == 'loadcurve' && view === 'icon'"
                  :ref="item.id"
                  :seriesDetails="[item]"
                  :enable-x-axies-labels="false"
                  :enableTooltip="false"
                  :enable-y-axies-labels="false"
                  :enable-legend="false"
                  data-dz-thumbnail-bg
                  class="data-dz-thumbnail-bg"
                ></Chart>
              </div>
              <!-- Details and meta data -->
              <div class="dz-details">
                <!-- Editable name input -->
                <input
                  class="dz-filename rename"
                  v-model="item.name"
                  placeholder="Bezeichnung eingeben..."
                  @change="updateMetadata(item)"
                  :disabled="database.access_level == 'read'"
                />
                <span
                  v-if="item.hasOwnProperty('tags')"
                  :style="{ 'background-color': item.tags[0].color }"
                  class="badge badge-secondary"
                  >{{ item.tags[0].name }}</span
                >
                <!-- Show src only for series after operations -->
                <div
                  v-if="
                    item.ts_type == 'loadcurve' &&
                    item.status == 'success' &&
                    item.unit === null
                  "
                  :class="{ 'show-on-hover': view != 'list' }"
                >
                  <select
                    v-model="item.unit"
                    @change="putElement(item, true)"
                    :disabled="database.access_level == 'read'"
                  >
                    <option v-for="unit in unitList" :key="unit">
                      {{ unit }}
                    </option>
                  </select>
                </div>
                <div
                  v-if="
                    item.ts_type === 'loadcurve' &&
                    item.status === 'success' &&
                    item.unit === null
                  "
                >
                  <select
                    v-model="item.unit"
                    @change="putElement(item, true)"
                    :disabled="database.access_level == 'read'"
                  >
                    <option v-for="unit in unitList" :key="unit">
                      {{ unit }}
                    </option>
                  </select>
                </div>
                <!--convert-->
                <div
                  v-if="
                    item.ts_type === 'loadcurve' &&
                    item.status === 'success' &&
                    item.unit !== null
                  "
                  :class="{ 'show-on-hover': view !== 'list' }"
                >
                  <select
                    :value="item.unit"
                    @change="openChangeUnit($event.target.value, item)"
                  >
                    <option v-for="unit in unitList" :key="unit">
                      {{ unit }}
                    </option>
                  </select>
                </div>

                <div
                  v-if="item.ts_type == 'loadcurve' && item.status == 'success'"
                >
                  {{ renderDateRange(item.start, item.end) }}
                </div>

                <div
                  v-if="item.ts_type == 'loadcurve' && item.status == 'success'"
                  :class="{ 'show-on-hover': view != 'list' }"
                >
                  Summe: {{ formatNumber(item.sum) }}
                </div>
                <div
                  style="display: flex"
                  v-if="item.ts_type == 'loadcurve' && item.status == 'success'"
                >
                  <span :class="{ 'show-on-hover': view != 'list' }"
                    >Gesamtmenge: </span
                  ><span class="ellipsis-text"
                    >{{ formatNumber(item.quantity) }}
                    {{ getQuantityUnit(item) }}</span
                  >
                </div>
              </div>
              <div class="dz-image">
                <div
                  class="data-dz-thumbnail-bg-overlay"
                  v-bind:class="{
                    loading:
                      (deleteLoading && item.isLoading) ||
                      item.status === 'created',
                  }"
                >
                  <ul class="tools">
                    <li class="share" title="Teilen" @click="shareItem(item)">
                      <a>share</a>
                    </li>
                    <li
                      v-if="database.access_level != 'read'"
                      title="Duplizieren"
                      class="duplicate"
                      @click="duplicateElement(item)"
                    >
                      <a>duplicate</a>
                    </li>
                    <li
                      class="download"
                      title="Download"
                      @click="exportItem(item, true)"
                    >
                      <a>
                        <span class="accessibility">Download xls</span>
                      </a>
                    </li>
                    <li
                      v-if="
                        database.access_level !== 'read' && !database.add_only
                      "
                      data-dz-delete
                      class="delete"
                      title="Löschen"
                      @click="removeElement(item, true)"
                    >
                      <a>delete</a>
                    </li>
                    <li
                      class="dropdown"
                      title="Mehr"
                      @click="toggleActionDropdown()"
                    >
                      <a>mehr</a>
                    </li>
                  </ul>
                  <!-- Dropdown menu for actions-->
                  <div class="dropdown action-dropdown">
                    <ul
                      class="item-hover"
                      :class="{ 'icon-view': view === 'icon' }"
                      @mouseleave="hideActionDropdown()"
                      v-if="isActionDropdownVisible && elOnHoverIdx === item.id"
                    >
                      <li
                        class="listitem-hover dropdown-action-item"
                        v-for="a in actionList"
                        :key="a.id"
                        @click="runAction(a.id, item.id)"
                      >
                        <div
                          class="loadingoverlay"
                          v-if="isDatabaseDropDownLoading(a.id, item.id)"
                        >
                          <div class="custom-table-progress-icon"></div>
                        </div>
                        {{ a.name }}
                      </li>
                      <li
                        class="create-new-action"
                        @click="createNewAction(item.id)"
                      >
                        <i class="far fa-plus-square"></i>Neue Aktion hinzufügen
                      </li>
                    </ul>
                  </div>

                  <div
                    class="checker"
                    v-if="!(item.isLoading || item.status === 'created')"
                  >
                    <span v-bind:class="{ checked: isSelectedItem(item.id) }">
                      <input
                        type="checkbox"
                        @click="checkSelectedItemOnClick($event, item)"
                      />
                    </span>
                  </div>
                  <a
                    class="btn-oval"
                    @click="goTo(item.id)"
                    v-if="
                      item.ts_type == 'loadcurve' &&
                      item.status == 'success' &&
                      !item.isLoading &&
                      !isActionDropdownVisible
                    "
                    >Anzeigen</a
                  >
                  <a
                    class="btn-oval"
                    @click="showMetadata(item)"
                    v-if="item.ts_type == 'file' && item.status != 'uploading'"
                    >Report</a
                  >
                  <p v-if="item.status == 'uploading'">
                    Datei wird bearbeitet, Lastkurve wird in Kürze als Grafik
                    angezeigt...
                  </p>
                  <div
                    class="progress-icon"
                    v-if="item.isLoading || item.status === 'created'"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="load-list"
          v-show="view === 'list' && !showLoadingSpinner"
          :class="{
            'modal-open': isChangeUnitModalOpen,
            'dropdown-open': dropdownOpen,
          }"
        >
          <div
            v-for="(item, indx) in customFilter"
            :key="indx"
            :index="parseInt(indx) + 1"
            :ref="item.id"
            class="dz-preview dz-file-preview"
            :class="[
              {
                checked: isSelectedItem(item.id),
                'higher-zIndex': currentOpenListViewWattDropdown == item.id,
              },
              view,
            ]"
            @mouseenter="elOnHoverIdx = item.id"
            @mouseleave="hideActionDropdown()"
          >
            <!-- v-bind:style="{
              zoom: getZoom(),
            }" -->
            <div dz-preview-wrapper class="dz-preview-wrapper">
              <!-- Loading -->
              <div
                class="dz-image"
                v-show="item.isLoading || item.status === 'created'"
              >
                <div class="data-dz-thumbnail-bg"></div>
                <div
                  class="data-dz-thumbnail-bg-overlay"
                  v-bind:class="{ loading: item.isLoading }"
                  v-show="item.isLoading || item.status === 'created'"
                >
                  <div class="progress-icon"></div>
                </div>
              </div>
              <!-- Details and meta data -->
              <div class="dz-details">
                <!-- checker -->
                <div class="checker">
                  <span v-bind:class="{ checked: isSelectedItem(item.id) }">
                    <input
                      type="checkbox"
                      :checked="isSelectedItem(item.id)"
                      @click="checkSelectedItemOnClick($event, item)"
                    />
                  </span>
                </div>

                <!-- Name -->
                <div class="filename-rename-wrap">
                  <input
                    class="dz-filename rename"
                    v-model="item.name"
                    placeholder="Bezeichnung eingeben..."
                    @change="updateMetadata(item)"
                    :disabled="database.access_level == 'read'"
                  />
                  <span
                    v-if="item.hasOwnProperty('tags')"
                    :style="{ 'background-color': item.tags[0].color }"
                    class="badge badge-secondary filename-rename-badge"
                    >{{ item.tags[0].name }}</span
                  >
                </div>
                <!-- uploading dots -->
                <div
                  class="status-icon"
                  v-if="
                    item.status == 'uploading' || item.status == 'processing'
                  "
                >
                  <div class="dot-flashing"></div>
                </div>

                <!-- meta data -->
                <!--re-interpret unit-->
                <div
                  class="listview-dropdown"
                  v-if="
                    item.ts_type === 'loadcurve' &&
                    item.status === 'success' &&
                    item.unit === null
                  "
                >
                  <generalDropdown
                    :disabled="database.access_level == 'read'"
                    :uniqueId="item.id"
                    @toggleListViewZIndex="toggleListViewZIndex"
                  >
                    <template v-slot:selectFilter>
                      <div class="listview-dropdown-text">{{ item.unit }}</div>
                    </template>
                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="unit in unitList"
                        :key="unit"
                        @click="putElement(item, true, unit)"
                      >
                        {{ unit }}
                      </b-dropdown-item>
                    </template>
                  </generalDropdown>
                </div>
                <!--convert-->
                <div
                  class="listview-dropdown"
                  v-if="
                    item.ts_type === 'loadcurve' &&
                    item.status === 'success' &&
                    item.unit !== null
                  "
                >
                  <generalDropdown
                    :disabled="database.access_level == 'read'"
                    :uniqueId="item.id"
                    @toggleListViewZIndex="toggleListViewZIndex"
                  >
                    <template v-slot:selectFilter>
                      <div class="listview-dropdown-text">{{ item.unit }}</div>
                    </template>
                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="unit in unitList"
                        :key="unit"
                        @click="openChangeUnit(unit, item)"
                      >
                        {{ unit }}
                      </b-dropdown-item>
                    </template>
                  </generalDropdown>
                </div>
                <div
                  v-if="item.ts_type == 'loadcurve' && item.status == 'success'"
                >
                  <span class="ellipsis-text">
                    {{ renderDateRange(item.start, item.end) }}
                  </span>
                </div>
                <div
                  v-if="item.ts_type == 'loadcurve' && item.status == 'success'"
                >
                  <span class="ellipsis-text">{{
                    formatNumber(item.sum)
                  }}</span>
                </div>
                <div
                  v-if="item.ts_type == 'loadcurve' && item.status == 'success'"
                >
                  <span class="ellipsis-text"
                    >{{ formatNumber(item.quantity) }}
                    {{ getQuantityUnit(item) }}</span
                  >
                </div>
                <div
                  v-if="item.ts_type == 'loadcurve' && item.status == 'success'"
                >
                  <span class="ellipsis-text">{{
                    formatDatetime(item.created, '')
                  }}</span>
                </div>
              </div>

              <!-- button -->

              <div class="tools-oval-wrapper">
                <!-- Status img -->
                <div
                  class="status-img"
                  v-if="item.ts_type == 'file' && item.status == 'failed'"
                >
                  <img src="../assets/img/status_icon_failed.svg" />
                </div>
                <div
                  class="status-img"
                  v-if="item.ts_type == 'file' && item.status == 'success'"
                >
                  <img src="../assets/img/status_icon_success.svg" />
                </div>
                <div
                  class="btn-oval"
                  @click="goTo(item.id)"
                  v-if="
                    item.ts_type == 'loadcurve' &&
                    item.status == 'success' &&
                    !item.isLoading &&
                    !isActionDropdownVisible
                  "
                >
                  <a>Anzeigen</a>
                </div>
                <div
                  class="btn-oval"
                  @click="showMetadata(item)"
                  v-if="item.ts_type == 'file' && item.status != 'uploading'"
                >
                  <a>Report</a>
                </div>

                <!-- tools -->
                <ul class="tools">
                  <li title="Teilen" @click="shareItem(item)">
                    <img
                      src="../assets/img/share_grey.svg"
                      class="tool-icon"
                      alt="share"
                    />
                  </li>
                  <li
                    v-if="database.access_level != 'read'"
                    title="Duplizieren"
                    @click="duplicateElement(item)"
                  >
                    <img
                      src="../assets/img/copy_grey.svg"
                      class="tool-icon"
                      alt="copy"
                    />
                  </li>
                  <li title="Download" @click="exportItem(item, true)">
                    <img
                      src="../assets/img/download_grey.svg"
                      class="tool-icon"
                      alt="download"
                    />
                  </li>
                  <li
                    v-if="
                      database.access_level !== 'read' && !database.add_only
                    "
                    data-dz-delete
                    title="Löschen"
                    @click="removeElement(item, true)"
                  >
                    <img
                      src="../assets/img/delete_grey.svg"
                      class="tool-icon"
                      alt="delete"
                    />
                  </li>
                  <li class="" title="Mehr">
                    <generalDropdown
                      :uniqueId="item.id"
                      @toggleListViewZIndex="toggleListViewZIndex"
                      :isCaretVisible="false"
                      :disabled="
                        !isActionDropdownVisible && elOnHoverIdx !== item.id
                      "
                    >
                      <template v-slot:iconContainer>
                        <img
                          src="../assets/img/more-icon.svg"
                          class="tool-icon more-icon"
                          alt="delete"
                      /></template>
                      <template v-slot:optionData>
                        <b-dropdown-item
                          v-for="action in actionList"
                          :key="action.id"
                          @click="runAction(action.id, item.id)"
                          class="dropdown-action-item"
                        >
                          <div
                            class="loadingoverlay"
                            v-if="isDatabaseDropDownLoading(action.id, item.id)"
                          >
                            <div class="custom-table-progress-icon"></div>
                          </div>
                          {{ action.name }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="createNewAction(item.id)">
                          <i class="far fa-plus-square me-2"></i>Neue Aktion
                          hinzufügen
                        </b-dropdown-item>
                      </template>
                    </generalDropdown>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <button
          @click="scrollToTopOfLoadProfileList()"
          v-if="isScrollToTopButtonVisible"
          class="go-to-top"
          :class="{
            'group-action-open':
              showGroupAction &&
              !htmlViewerModal.isHtmlViewerVisible &&
              !isLoading,
          }"
          title="Zum start scrollen"
        >
          <span></span>
        </button>
        <!-- white space -->
        <div
          class="white-space"
          :class="{ 'extra-height': showGroupAction }"
        ></div>
      </div>
      <vue-dropzone
        :options="dropzoneOptions"
        :awss3="awss3"
        :use-custom-dropzone-options="true"
        :include-styling="false"
        @vdropzone-thumbnail="thumbnail"
        @vdropzone-queue-complete="dropzoneOptions.isLoading = false"
        @vdropzone-file-added="attachListener"
        @vdropzone-files-added="filesAdded"
        @vdropzone-success="successEvent"
        @vdropzone-error="errorEvent"
        @vdropzone-sending="sendingEvent"
        v-show="uploadActive && !isLoading"
        id="customdropzone"
        ref="dropzone"
        class="customdropzone dragNDropBackGround dragDropLoading"
      >
      </vue-dropzone>
      <seriesComparator
        v-if="isComparatorVisible"
        :ts="selectedSeries"
        @close="closeComparator()"
      />
      <LoadProfileSettings
        ref="settings"
        v-show="settingsIsVisible"
        @close="hideSettings()"
      />
      <hedgeParamsModal
        v-if="hedgeParamsModal.isHedgeParamsModalVisible"
        @close="closeHedgeParamsModal"
        @hedge="quantityHedgeSelectedLoads"
        :loadsWithoutUnit="hedgeParamsModal.loadsWithoutUnit"
        :params="hedgeParamsModal.params"
      >
      </hedgeParamsModal>
      <htmlViewer
        v-if="htmlViewerModal.isHtmlViewerVisible"
        @close="closeHtmlViewer"
        :myHtml="htmlViewerModal.myHtml"
      >
      </htmlViewer>
      <sumParamsModal
        v-if="sumParamsModal.isSumParamsModalVisible"
        @close="closeSumParamsModal"
        @sum="uploadBeforeSum"
        :loadsWithoutUnit="sumParamsModal.loadsWithoutUnit"
      >
      </sumParamsModal>
      <forecastParamsModal
        v-if="forecastParamsModal.isForecastParamsModalVisible"
        @close="closeForecastParamsModal"
        @map="prepareForecastSelectedLoads"
        :forecastMethod="forecastParamsModal.forecastMethod"
        :params="forecastParamsModal.params"
      >
      </forecastParamsModal>
      <subtractParamsModal
        v-if="subtractParamsModal.isSubtractParamsModalVisible"
        @close="closeSubtractParamsModal"
        @subtract="subtractSelectedLoads"
        :selectedItems="subtractParamsModal.selectedItems"
      >
      </subtractParamsModal>
      <mergeLoadsModal
        v-if="mergeLoadsModal.isMergeLoadsModalVisible"
        @close="closeMergeLoadsModal"
        :selectedItem="mergeLoadsModal.selectedItem"
        :isLoading="mergeLoadsModal.isLoading"
        @merge="parseSelectedLoadFile"
      >
      </mergeLoadsModal>
      <LoadProfileDetails
        v-if="isProfileDetailsVisible"
        @close="toggleLoadDetails"
        @download="(...args) => this.exportLoad(...args)"
        @saveFile="putElement"
        :isAddOnly="database.add_only"
        :loadProfile="selectedLoadProfile"
        :accessLevel="database.access_level"
        :database="database"
      >
      </LoadProfileDetails>
    </div>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone';
import Chart from './charts/LineChart.vue';
import ModalShare from './modals/ModalShare.vue';
import ModalBox from './modals/ModalBox.vue';
import hedgeParamsModal from './modals/hedgeParamsModal.vue';
import forecastParamsModal from './modals/forecastParamsModal.vue';
import subtractParamsModal from './modals/subtractParamsModal.vue';
import mergeLoadsModal from './modals/mergeLoadsModal.vue';
import sumParamsModal from './modals/sumParamsModal.vue';
import ReportViewer from './modals/reportViewer.vue';
import htmlViewer from './modals/htmlViewer.vue';
import SlpProfile from './SlpProfile.vue';
import seriesComparator from './widgets/seriesComparator.vue';
import Weather from './Weather.vue';
import LoadProfileDetails from './LoadProfileDetails.vue';
import * as JSZip from 'jszip';
import changeUnitModal from './modals/changeUnitModal.vue';
import loadProfileDataSchema from '../assets/data-schemas/loadProfileDataSchema.json';
import moment from 'moment';
import LoadProfileSettings from './LoadProfileSettings.vue';

//amplify
import { components } from 'aws-amplify-vue';
import Store from '../store/store';
import { Auth } from 'aws-amplify';
import {
  getUserTabels,
  removeCustomItem,
  sumLoadProfiles,
  updateLoadFiles,
  parseLoadFile,
  mergeLoads,
  calculateMetaDataApi,
} from '../services/load-profile.services';
import GeneralDropdown from './core/general-dropdown.vue';
import { HttpStatusCode } from '../enum/httpStatus.enum';
import { getFlowLastId } from '../utils/helpers';
import { runFlowById } from '../services/workflow.service';
import { mapGetters } from 'vuex';

export default {
  name: 'LoadProfileList',

  data() {
    return {
      deleteLoading: false,
      dropdownOpen: false,
      offsetTop: 0,
      id: '',
      name: '',
      view: 'list',
      search: '',
      searchActive: false,
      unitList: ['kWh', 'kW', 'MW', 'MWh'],
      modalBox: {
        showAfterQueueIsDone: false,
        title: '',
        msg: [],
        btnCaption: 'Schliessen',
        showModalBox: false,
      },
      shareSetting: {
        isShareModalVisible: false,
        artefact: '',
        description: '',
        attachment: null,
      },
      reportViewer: {
        isReportViewerVisible: false,
        title: '',
        json: '',
        btnCaption: '',
      },
      hedgeParamsModal: {
        isHedgeParamsModalVisible: false,
        loadsWithoutUnit: [],
        params: {
          products: 'Months',
          blocks: 'Base',
        },
      },
      sumParamsModal: {
        isSumParamsModalVisible: false,
        loadsWithoutUnit: [],
      },
      forecastParamsModal: {
        isForecastParamsModalVisible: false,
        forecastMethod: null,
        params: {
          choice: null,
          start: null,
          end: null,
        },
      },
      refreshSettings: {
        interval: 500,
        lastRefresh: null,
        que: [],
        queue: 0,
        stop: false,
      },
      subtractParamsModal: {
        isSubtractParamsModalVisible: false,
        selectedItems: [],
        saveLoadsWithNewUnit: false,
      },
      mergeLoadsModal: {
        isLoading: false,
        isMergeLoadsModalVisible: false,
        selectedItems: [],
      },
      htmlViewerModal: {
        isHtmlViewerVisible: false,
        myHtml: null,
      },
      isSlpProfileVisible: false,
      isComparatorVisible: false,
      lastTokenRefresh: null,
      isWeatherVisible: false,
      settingsIsVisible: false,
      isProfileDetailsVisible: false,
      showMore: false,
      showActionsDropdown: false,
      isAddOptionsVisible: false,
      uploadActive: false,
      isLoading: false,
      lastID: null,
      isRefreshing: false,
      hideTimer: null,
      items: [],
      fileUpdateInterval: null,
      filter: 'unset',
      operationRunningPlaceholder: null,
      filterTime: 9999999999999,
      timeFilterOptions: [
        {
          caption: 'Alle',
          value: 9999999999999,
          selected: true,
        },
        {
          caption: '1 Stunde',
          value: 3600000,
          selected: false,
        },
        {
          caption: '1 Tag',
          value: 86400000,
          selected: false,
        },
        {
          caption: '1 Woche',
          value: 604800000,
          selected: false,
        },
        {
          caption: '1 Monat',
          value: 2419200000,
          selected: false,
        },
      ],
      filterOptions: {
        unset: {
          caption: 'Alle',
          condition: [],
        },
        reports: {
          caption: 'Reports',
          condition: [
            {
              attr: 'ts_type',
              operand: '==',
              value: 'file',
            },
          ],
        },
        timeseries: {
          caption: 'Zeitreihen',
          condition: [
            {
              attr: 'ts_type',
              operand: '==',
              value: 'loadcurve',
            },
            {
              attr: 'status',
              operand: '==',
              value: 'created',
            },
            {
              attr: 'status',
              operand: '==',
              value: 'uploading',
            },
          ],
        },
      },
      zoom: 70,
      tsOperationsEndPoint: process.env.VUE_APP_TS_CALCULATION_API,
      databaseEndPoint: process.env.VUE_APP_DATA_API,
      emailEndPoint: process.env.VUE_APP_E_MAIL_API,
      translatedFileSource: {
        mapping: 'Ausgerollt',
        modified: 'Modifiziert',
        hedge: 'Hedge',
        sum: 'Summenlastgang',
        subtract: 'Restwerte',
        SLP: 'Standartlastprofil',
        REP: 'Erzeugungsprofil',
        converted: 'Einheit konvertiert',
      },
      itemsToProcess: 0,
      dropzoneOptions: {
        previewTemplate: this.template(),
        isLoading: false,
        timeout: 1000000,
        renameFilename: function (filename, file) {
          return (file.renameFilename = Math.round(
            Math.random() * 100000 + new Date().getTime()
          ));
        },
        acceptedFiles: '.csv,.xlsx',
        maxFiles: 25,
        autoProcessQueue: false,
      },
      awss3: {
        signingURL: (f) => {
          return (
            process.env.VUE_APP_DATA_API +
            '/signed-url/' +
            encodeURIComponent(this.database.name + '_' + f.renameFilename)
          );
        },
        headers: {
          Authorization: null,
        },
        params: {},
        sendFileToServer: false,
      },
      selectedLoadProfile: null,
      refreshTimer: null,
      isChangeUnitModalOpen: false,
      loadWaitingForUnitChange: null,
      unitValues: {
        new: null,
        old: null,
        lastOpnedLoad: null,
      },
      isAddFilterVisible: false,
      filters: [],
      activeFilter: null,
      isClickOutsideDelayed: true,
      isEditFilterVisible: false,
      operatorOption: [
        {
          label: 'beinhaltet',
          opperand: '.includes(',
          visibility: ['text', 'number', 'radio'],
        },
        {
          label: 'beinhaltet nicht',
          opperand: '!.includes(',
          visibility: ['text', 'number', 'radio'],
        },
        {
          label: 'ist genau',
          opperand: '==',
          visibility: ['text', 'number', 'radio', 'timestamp'],
        },
        {
          label: 'ist nicht',
          opperand: '!=',
          visibility: ['text', 'number', 'radio', 'timestamp'],
        },
        {
          label: 'ist grösser',
          opperand: '>',
          visibility: ['number', 'timestamp'],
        },
        {
          label: 'ist grösser oder gleich',
          opperand: '>=',
          visibility: ['number', 'timestamp'],
        },
        {
          label: 'ist kleiner',
          opperand: '<',
          visibility: ['number', 'timestamp'],
        },
        {
          label: 'ist kleiner oder gleich',
          opperand: '<=',
          visibility: ['number', 'timestamp'],
        },
      ],
      highlightItems: {},
      itemOrder: [],
      isActionDropdownVisible: false,
      elOnHoverIdx: null,
      lastSelectedItemIdForShiftSelect: null,
      selectedItemIds: [],
      isScrollToTopButtonVisible: false,
      currentOpenListViewWattDropdown: false,
      tagsFilterOptions: [],
      listActionDropdownOptions: [],
      isActionDropDownLoading: {
        itemID: null,
        actionID: null,
      },
    };
  },
  props: {
    database: Object,
    itemID: String,
    activeDatabase: String,
    isNewDataTypeModalVisible: Boolean,
  },
  methods: {
    template: function () {
      return `
        <div class="dz-preview dz-file-preview">
                <div dz-preview-wrapper class="dz-preview-wrapper">
                    <div class='container'>
                    </div>
                    <div class="dz-image">
                        <div data-dz-thumbnail-bg class="data-dz-thumbnail-bg loading">
                            <div data-dz-thumbnail-bg-overlay class="data-dz-thumbnail-bg-overlay loading">
                              <div class='progress-icon'>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="dz-progress">
                        <span class="dz-upload" data-dz-uploadprogress></span>
                    </div>
                    <div class="dz-details">
                        <h2 class="rename dz-filename" contenteditable="true">
                            <span data-dz-name ></span>
                        </h2>
                    </div>
                    <div class="dz-error-message">
                        <span data-dz-errormessage></span>
                    </div>
                    <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                    <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                </div>
        </div>`;
    },
    isDatabaseDropDownLoading(actionid, itemid) {
      return (
        this.isActionDropDownLoading.itemID !== null &&
        this.isActionDropDownLoading.actionID !== null &&
        this.isActionDropDownLoading.itemID == itemid &&
        this.isActionDropDownLoading.actionID == actionid
      );
    },

    selectAll() {
      this.selectedItemIds = this.filteredItems.map((item) => item.id);
      // Update token
      this.checkRefreshToken();
    },

    unselectAll() {
      this.selectedItemIds = [];
      // Update token
      this.checkRefreshToken();
    },

    setFilter(filter) {
      if (typeof filter != 'undefined') this.filter = filter;
      this.getLoadDataForItemsInViewPoint();
    },

    setTimeFilter(time) {
      if (time.selected) {
        time.selected = false;
        this.filterTime = 9999999999999;
      } else {
        // Unselect all
        this.timeFilterOptions.forEach((option) => {
          option.selected = false;
        });
        this.filterTime = time.value;
        time.selected = true;
      }
    },

    // set focus on input (search)
    toggleSearch() {
      this.searchActive = !this.searchActive;
      if (this.searchActive) {
        this.$refs.search.focus();
      } else {
        this.search = '';
      }
    },

    onLoadProfileListScrolled() {
      this.offsetTop = window.pageYOffset || this.$refs.loadlist.scrollTop;
      this.$refs.loadlist.scrollTop > 40
        ? !this.isScrollToTopButtonVisible
          ? (this.isScrollToTopButtonVisible = true)
          : ''
        : this.isScrollToTopButtonVisible
        ? (this.isScrollToTopButtonVisible = false)
        : '';
    },

    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();

      return (
        this.$refs.loadlist.getBoundingClientRect().top <= rect.top &&
        rect.top <= this.$refs.loadlist.getBoundingClientRect().bottom
      );
    },

    getLoadDataForItemsInViewPoint() {
      if (this.view !== 'icon') return false;

      let el, isLoad, hasData, isLoading;

      let items = this.filteredItems;
      for (let i = 0; i < items.length; i++) {
        if (items[i].id) {
          // Get element
          el = this.$refs[items[i].id];

          // Only get LoadData if the item is a load curve
          // and have no data yet and visible on the screen
          isLoad = items[i].ts_type == 'loadcurve';
          hasData = items[i].hasOwnProperty('data');
          isLoading = items[i].hasOwnProperty('isLoading')
            ? items[i].isLoading
            : false;

          if (el && isLoad && !hasData && !isLoading)
            if (this.isElementInViewport(el[0])) {
              items[i].isLoading = true;
              this.getLoadDataById(items[i].id)
                .then((result) => {
                  this.replaceItem(result);
                })
                .catch(() => {});
            }
        }
      }
    },

    thumbnail(file, dataUrl) {
      var j, len, ref, thumbnailElement;
      if (file.previewElement) {
        file.previewElement.classList.remove('dz-file-preview');
        ref = file.previewElement.querySelectorAll('[data-dz-thumbnail-bg]');
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j];
          thumbnailElement.alt = file.name;
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
        }
        return setTimeout(
          (function () {
            return function () {
              return file.previewElement.classList.add('dz-image-preview');
            };
          })(this),
          1
        );
      }
    },

    attachListener(file) {
      this.addParseParamsToRequest();

      var j, len, checkboxElements, removeButton;
      if (file.previewElement) {
        checkboxElements =
          file.previewElement.querySelectorAll('[data-dz-checkbox]');
        for (j = 0, len = checkboxElements.length; j < len; j++) {
          checkboxElements[j].addEventListener(
            'click',
            function () {
              if (this.classList.contains('checked')) {
                this.classList.remove('checked');
                file.previewElement.classList.remove('checked');
              } else {
                this.classList.add('checked');
                file.previewElement.classList.add('checked');
              }
            },
            false
          );
        }
        removeButton = file.previewElement.querySelectorAll('[data-dz-delete]');
        for (j = 0, len = removeButton.length; j < len; j++) {
          removeButton[j].addEventListener(
            'click',
            function () {
              file.previewElement.remove();
            },
            false
          );
        }
      }
    },

    checkSelectedItemOnClick(event, item) {
      const currentItemSelectedIndex = this.customFilter.findIndex(
        (itemDetails) =>
          itemDetails.id == this.lastSelectedItemIdForShiftSelect &&
          this.isSelectedItem(itemDetails.id)
      );
      if (
        event.shiftKey &&
        currentItemSelectedIndex != -1 &&
        !this.isSelectedItem(item.id)
      ) {
        this.selectAllItemsBetweenShiftPressed(currentItemSelectedIndex, item);
      } else {
        this.toggleSeletedItem(item.id);
        this.lastSelectedItemIdForShiftSelect = item.id;
      }
      this.$forceUpdate();
    },

    sendingEvent() {
      // Dropzone loading, get File numbers
      if (!this.dropzoneOptions.isLoading) {
        this.itemsToProcess += 1;
        this.dropzoneOptions.isLoading = true;
      }
    },

    filesAdded(files) {
      setTimeout(() => {
        if (files.length > 25) {
          this.$refs.dropzone.removeAllFiles(true);
        } else this.$refs.dropzone.processQueue();
      }, 100);
    },

    addParseParamsToRequest() {
      this.awss3.params = this.parseSettingsAsObject;
    },

    showDropZone() {
      this.uploadActive = true;
      this.isAddOptionsVisible = true;
    },

    showAddOptions() {
      clearInterval(this.hideTimer);
      this.isAddOptionsVisible = true;
    },

    closeHtmlViewer() {
      this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', false);
      this.scheduleUpdateFiles();
    },

    hideDropZone() {
      this.$set(this, 'uploadActive', false);
      this.$set(this, 'isAddOptionsVisible', false);
    },

    hideAddOptionsWithDelay() {
      this.hideTimer = setTimeout(this.hideAddOptions, 500);
    },

    hideAddOptions() {
      this.isAddOptionsVisible = false;
    },

    hideSettings() {
      this.settingsIsVisible = false;
    },

    showSettings() {
      this.settingsIsVisible = true;
    },
    hideActionDropdown() {
      this.elOnHoverIdx = null;
      this.isActionDropdownVisible = false;
      this.dropdownOpen = false;
    },
    toggleActionDropdown() {
      // For list-view we must toggle the transform property
      if (this.view === 'list') {
        // if dropdown closed toggle css before open dropdown
        if (!this.dropdownOpen) {
          this.dropdownOpen = true;
          setTimeout(() => {
            this.isActionDropdownVisible = !this.isActionDropdownVisible;
          }, 150);
        }
      } else {
        this.isActionDropdownVisible = !this.isActionDropdownVisible;
      }
    },

    toggleActionsDropdown() {
      this.showActionsDropdown = !this.showActionsDropdown;
    },

    closeDropdowns() {
      this.showActionsDropdown = false;
      this.showMore = false;
    },
    formatNumber(num) {
      let unit;

      if (num == null) return 'Nicht vorhanden';
      else if (num.hasOwnProperty('value')) {
        if (num.value != null) {
          num = num.value;
          unit = num.unit;
        } else return 'Nicht vorhanden';
      }

      let val = (num / 1)
        .toFixed(2)
        .replace('.', ',')
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      return unit ? val + ' ' + unit : val;
    },

    togglePlusBtn() {
      switch (this.appSettings.app) {
        case 'loadparser':
        case 'edm':
        case 'default':
          this.toggleUpload();
          break;
        case 'slp-generator':
          this.showSlpProfile();
          break;
        case 'weather':
          this.showWeather();
          break;
      }

      // Update token
      this.checkRefreshToken();
    },

    toggleUpload() {
      // Set header for signed-url request
      this.refreshSession().then(() => {
        this.awss3.headers.Authorization =
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken;
      });

      this.uploadActive = !this.uploadActive;
      if (this.uploadActive) {
        this.showDropZone();
        this.showAddOptions();
      } else {
        this.hideDropZone();
        this.hideAddOptionsWithDelay();
      }
    },

    callUpload() {
      this.$refs.dropzone.$refs.dropzoneElement.click();
    },

    removeSelectedElements() {
      var fileKeys = [];
      this.selectedElements.forEach((element) => {
        element.isLoading = true;
        fileKeys.push(element.id);
      });

      // Send all keys to API for delete
      var url = process.env.VUE_APP_DATA_API;
      url += '/custom-item';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      let payload = {
        keys: fileKeys,
        database_name: this.database.name,
      };

      // For usability start update before removing
      this.scheduleUpdateFiles();

      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'DELETE',
      }).then((response) => {
        if (response.status == 401) this.handleExpiredAuth();
        else this.scheduleUpdateFiles();
      });
    },

    // Put element to DB
    async putElement(fileContent, evaluateLoad = false, unit = null) {
      fileContent.isLoading = true;
      // Remove frontend
      let copyContent = this.removeFrontendProps(fileContent);
      // Check token before api call
      this.checkRefreshToken();
      if (!copyContent.unit && unit) {
        copyContent = await this.getLoadDataById(copyContent.id);
        copyContent.unit = unit;
        await this.calculateMetaData(copyContent);
      }
      if (unit && !copyContent.unit) copyContent.unit = unit;
      let payload = {
        file_content: copyContent,
      };
      try {
        const response = await updateLoadFiles(payload, {
          params: evaluateLoad ? { evaluate_load: true } : {},
        });
        this.scheduleUpdateFiles();
        fileContent.isLoading = false;
        this.removeFromItemQueue(30000);
        return response.data;
      } catch (e) {
        this.isLoading = false;
        // Display modal after queue is done
        this.$set(this.modalBox, 'showAfterQueueIsDone', true);
        this.$set(
          this.modalBox.msg,
          this.modalBox.msg.length,
          'Beim speichern der Zeitreihe ' +
            fileContent.name +
            ' ist ein Fehler aufgetreten.'
        );
        this.handleItemAfterFetchError(fileContent.id);
      }
    },

    exportSelectedLoads() {
      //TODO: use only filtered items which are selected
      this.selectedElements.forEach((element) => {
        if (element.ts_type == 'loadcurve') this.exportLoad(element, true);
        else this.exportJSON(element, true);
      });
    },

    checkLoadsBeforeSum() {
      // check selected period is more then 4 years
      if (!this.isSelectedSeriesTimePeriodValid()) {
        this.openTimePeriodValidModal();
        return;
      }
      // Only sum if daily freq is not mixed with qrterly or hrly
      if (!this.unmatchingFrequenciesSelected) {
        // Check if load without unit selected
        if (this.isLoadWithoutUnitSelected) {
          // Display the modal
          this.$set(
            this.sumParamsModal,
            'loadsWithoutUnit',
            this.selectedLoadsWithoutUnit
          );
          this.$set(this.sumParamsModal, 'isSumParamsModalVisible', true);
        } else {
          // Create loading element
          let id = this.createNewLoadID();
          this.createPreviewItem(id, this.selectedSeries[0].name);

          this.sumSelectedLoads(id);
        }
      } else {
        this.$set(this.modalBox, 'showAfterQueueIsDone', false);
        this.$set(
          this.modalBox.msg,
          this.modalBox.msg.length,
          'Tägiche Zeitreihen können nicht mit stündlichen oder viertelstündlichen Zeitreihen summiert werden.'
        );
        this.$set(this.modalBox, 'showModalBox', true);
      }
    },

    async uploadBeforeSum() {
      // Hide modal and show loading
      this.$set(this.sumParamsModal, 'isSumParamsModalVisible', false);

      // Save files before sum
      for (let l of this.sumParamsModal.loadsWithoutUnit) {
        await this.putElement(l);
      }

      // Create loading element
      let id = this.createNewLoadID();
      this.createPreviewItem(id, this.selectedSeries[0].name);

      this.sumSelectedLoads(id);

      // Check token before API call
      this.checkRefreshToken();
    },

    async sumSelectedLoads(id) {
      // Check token before API call
      this.checkRefreshToken();

      // Set itemsToProcess, 1 because only 1 request happens
      this.itemsToProcess += 1;

      // map only keys from selected series
      let keys = this.selectedSeries.map((series) => series.id);

      // Init request body
      var payload = {
        fileKeys: keys,
        output_key: id,
      };

      try {
        const response = await sumLoadProfiles(payload, {
          params: {
            handle_missing_units: 'consider_as_kWh',
            use_s3_bucket: true,
            save_result_to_s3_bucket: true,
          },
        });

        if (response.data.status == 'failed') this.putElement(response.data);
        this.scheduleUpdateFiles();
        this.removeFromItemQueue();
      } catch (e) {
        // Display modal after queue is done
        this.$set(this.modalBox, 'showAfterQueueIsDone', true);
        this.$set(
          this.modalBox.msg,
          this.modalBox.msg.length,
          'Beim Summieren von ' +
            this.selectedSeries[0].name +
            ' ist ein Fehler aufgetreten.'
        );

        this.handleItemAfterFetchError(id);
      }
    },

    avgSelectedLoads() {
      // Check token before API call
      this.checkRefreshToken();

      // map keys from selected series
      let keys = this.selectedSeries.map((series) => series.name);

      // Set itemsToProcess, 1 because only 1 request happens
      this.itemsToProcess += 1;

      // Make new name for Sum load
      let newTS = new Date().getTime();
      let oldTS =
        this.selectedSeries[0].id.split('_')[
          this.selectedSeries[0].id.split('_').length - 1
        ];
      let newID = this.selectedSeries[0].id.replace(oldTS, newTS);

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      // Init request body
      var payload = {
        fileKeys: keys,
      };

      // Get API endpoint & add function
      var url = process.env.VUE_APP_TS_CALCULATION_API;
      url += '/average';

      // Add URL params
      url += '?handle_missing_units=consider_as_kWh';
      url += '&use_s3_bucket=true';

      //post and get results
      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) this.handleExpiredAuth();
          else throw new Error('CORS');
        })
        .then((json) => {
          json.loadCurves[0].id = newID;
          this.putElement(json.loadCurves[0]);
          this.removeFromItemQueue();
        })
        .catch(() => {
          // Display modal after queue is done
          this.$set(this.modalBox, 'showAfterQueueIsDone', true);
          this.$set(
            this.modalBox.msg,
            this.modalBox.msg.length,
            'Bei der Mittelwertsberechnung von ' +
              this.selectedLoads[0].name +
              ' ist ein Fehler aufgetreten.'
          );

          this.itemsToProcess -= 1;
        });
    },

    async showHedgeParamsModal() {
      // Get selected loads without unit
      var selectedLoadsWithoutUnit = this.items.filter(
        (item) =>
          this.isSelectedItem(item.id) &&
          item.status == 'success' &&
          !item.series[0].unit
      );

      // Display the modal
      this.$set(
        this.hedgeParamsModal,
        'loadsWithoutUnit',
        selectedLoadsWithoutUnit
      );
      this.$set(this.hedgeParamsModal, 'isHedgeParamsModalVisible', true);
    },

    async quantityHedgeSelectedLoads(params) {
      // Get all selected loads
      var selectedLoads = this.items.filter(
        (item) => this.isSelectedItem(item.id) && item.status == 'success'
      );

      // Set params choosen by customer as default
      this.$set(this.hedgeParamsModal, 'params', params);

      // hedge loads after user added units
      for (let i = 0; i < selectedLoads.length; i++) {
        this.itemsToProcess += 1;

        let load = selectedLoads[i].series[0];
        this.callHedge(load);
      }
      this.closeHedgeParamsModal();
    },

    callHedge(load) {
      // create new load to keep original
      let loadCopy = Object.assign({}, load);

      // Check token before API call
      this.checkRefreshToken();

      // Get API endpoint & add function
      var url = this.tsOperationsEndPoint;
      url += '/quantity-neutral-hedge';

      // Make new name for hedged load
      let ts = new Date().getTime();
      var name = ts + '_' + this.getNameWithoutTimestamp(loadCopy.name);

      // Add new name to JSON
      loadCopy.name = name;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      // Init request body
      var payload = {
        loadCurve: loadCopy,
      };

      // Set URL params
      url += '?products=' + this.hedgeParamsModal.params.products;
      url += '&blocks=' + this.hedgeParamsModal.params.blocks;

      //post and get results
      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) this.handleExpiredAuth();
          else throw new Error('CORS');
        })
        .then((json) => {
          this.putElement(json);
          this.removeFromItemQueue();
        })
        .catch(() => {
          // Display modal after queue is done
          this.$set(this.modalBox, 'showAfterQueueIsDone', true);
          this.$set(
            this.modalBox.msg,
            this.modalBox.msg.length,
            'Beim Hedgen von ' + load.name + ' ist ein Fehler aufgetreten.'
          );

          this.handleItemAfterFetchError(load.id);
        });
    },

    showForecastParamsModalCalendar() {
      // Set default values for calendar forecast
      this.$set(this.forecastParamsModal, 'forecastMethod', 'calendar');
      this.$set(
        this.forecastParamsModal.params,
        'choice',
        'return_available_values'
      );
      this.$set(
        this.forecastParamsModal.params,
        'start',
        new Date('1 January ' + (new Date().getFullYear() + 1) + ' 00:00 UTC')
          .toISOString()
          .slice(0, -8)
      );
      this.$set(
        this.forecastParamsModal.params,
        'end',
        new Date('31 December ' + (new Date().getFullYear() + 1) + ' 23:45 UTC')
          .toISOString()
          .slice(0, -8)
      );
      this.$set(this.forecastParamsModal, 'isForecastParamsModalVisible', true);

      // Set placeholder for loading report
      this.operationRunningPlaceholder = 'Datei wird Ausgerollt...';
    },

    showForecastParamsModalTemp() {
      // Set default values for Temperature forecast
      this.$set(this.forecastParamsModal, 'forecastMethod', 'temperature');
      this.$set(
        this.forecastParamsModal.params,
        'choice',
        'handle_as_missing_values'
      );
      this.$set(this.forecastParamsModal.params, 'start', '2019-01-01T06:00');
      this.$set(this.forecastParamsModal.params, 'end', '2020-01-01T05:00');
      this.$set(this.forecastParamsModal, 'isForecastParamsModalVisible', true);
    },

    closeForecastParamsModal() {
      this.$set(
        this.forecastParamsModal,
        'isForecastParamsModalVisible',
        false
      );
    },

    prepareForecastSelectedLoads(p) {
      // Format date as expected by API
      let start = p.start.split('T')[0] + ' ' + p.start.split('T')[1];
      let end = p.end.split('T')[0] + ' ' + p.end.split('T')[1];
      if (this.forecastParamsModal.forecastMethod == 'calendar') {
        this.forecastCalendarSelectedLoads(p.state, start, end, p.choice);
      } else {
        this.forecastTempSelectedLoads(
          p.address,
          p.state,
          start,
          end,
          p.choice
        );
      }

      this.closeForecastParamsModal();
    },

    async forecastCalendarSelectedLoads(state, start, end, choice) {
      for (let item of this.selectedSeries) {
        // Get full load
        let series = await this.getLoadDataById(item.id);

        // Check token before API call
        this.checkRefreshToken();

        // Make new name for forecast load
        let newTS = new Date().getTime();
        let oldTS = series.id.split('_')[series.id.split('_').length - 1];
        series.id = series.id.replace(oldTS, newTS.toString());
        series.status = 'processing';

        // Put modified series to input bucket
        await this.putElement(series);

        // Increase queue
        this.itemsToProcess += 1;

        let myHeaders = new Headers();
        myHeaders.append(
          'Authorization',
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
        );
        myHeaders.append('content-type', 'application/json');

        // Get API endpoint & add function
        var url = process.env.VUE_APP_MAPPER_POWER_API;
        url += '/map';

        // Add url params
        url += '?file_key=' + encodeURIComponent(series.id);
        url += '&state=' + encodeURIComponent(state);
        url += '&start=' + encodeURIComponent(start);
        url += '&end=' + encodeURIComponent(end);
        url += '&handle_incomplete_src_data=' + encodeURIComponent(choice);
        url += '&use_s3_bucket=true';

        fetch(url, {
          headers: myHeaders,
          body: JSON.stringify({ loadCurve: null }),
          method: 'POST',
        })
          .then((response) => {
            if (response.status == 202) return response.json();
            else if (response.status == 401) this.handleExpiredAuth();
            else throw new Error('CORS');
          })
          .then(() => {
            //let name = json.responseMetadata.uploadedFile;
            //var reportName = "_report_" + name;
            //this.putElement(reportName, json);
            this.removeFromItemQueue();
          })
          .catch(() => {
            // Display modal after queue is done
            this.$set(this.modalBox, 'showAfterQueueIsDone', true);
            this.$set(
              this.modalBox.msg,
              this.modalBox.msg.length,
              'Beim Ausrollen von ' +
                item.series[0].name +
                ' ist ein Fehler aufgetreten.'
            );

            this.handleItemAfterFetchError(series.id);
          });
      }
    },

    forecastTempSelectedLoads(address, state, start, end, choice) {
      // Check token before API call
      this.checkRefreshToken();

      for (let item of this.selectedSeries) {
        this.itemsToProcess += 1;

        let myHeaders = new Headers();
        myHeaders.append(
          'Authorization',
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
        );
        myHeaders.append('content-type', 'application/json');

        // Init request body
        var payload = {
          loadCurve: item.series[0],
        };

        // Get API endpoint & add function
        var url = process.env.VUE_APP_MAPPER_GAS_API;
        url += '/map';

        // Add url params
        url += '?address=' + encodeURIComponent(address);
        url += '&state=' + state;
        url += '&start=' + encodeURIComponent(start);
        url += '&end=' + encodeURIComponent(end);
        url += '&handle_missing_values=' + choice;

        fetch(url, {
          body: JSON.stringify(payload),
          headers: myHeaders,
          method: 'POST',
        })
          .then((response) => {
            if (response.status == 200) return response.json();
            else if (response.status == 401) this.handleExpiredAuth();
            else throw new Error('CORS');
          })
          .then((json) => {
            this.putElement(json.loadCurves[0]);
            this.removeFromItemQueue();
          })
          .catch(() => {
            // Display modal after queue is done
            this.$set(this.modalBox, 'showAfterQueueIsDone', true);
            this.$set(
              this.modalBox.msg,
              this.modalBox.msg.length,
              'Beim Ausrollen von ' +
                item.series[0].name +
                ' ist ein Fehler aufgetreten.'
            );

            this.itemsToProcess -= 1;
          });
      }
    },

    showSubtractParamsModal() {
      // check selected period is more then 4 years

      if (!this.isSelectedSeriesTimePeriodValid()) {
        this.openTimePeriodValidModal();

        return;
      }

      // Only subtract if daily freq is not mixed with qrterly or hrly
      if (!this.unmatchingFrequenciesSelected) {
        // If series without units selected, save after input
        if (this.isLoadWithoutUnitSelected) {
          this.$set(this.subtractParamsModal, 'saveLoadsWithNewUnit', true);
        }

        this.$set(
          this.subtractParamsModal,
          'selectedItems',
          this.selectedSeries
        );
        this.$set(
          this.subtractParamsModal,
          'isSubtractParamsModalVisible',
          true
        );
      } else {
        this.$set(this.modalBox, 'showAfterQueueIsDone', false);
        this.$set(
          this.modalBox.msg,
          this.modalBox.msg.length,
          'Tägiche Zeitreihen können nicht mit stündlichen oder viertelstündlichen Zeitreihen subtrahiert werden.'
        );
        this.$set(this.modalBox, 'showModalBox', true);
      }
    },

    closeSubtractParamsModal() {
      this.$set(
        this.subtractParamsModal,
        'isSubtractParamsModalVisible',
        false
      );

      this.$set(this.subtractParamsModal, 'saveLoadsWithNewUnit', false);
    },

    async subtractSelectedLoads(series) {
      // Check token before API call
      this.checkRefreshToken();

      // Save files if user added units
      if (this.subtractParamsModal.saveLoadsWithNewUnit) {
        for (let s of series) {
          await this.putElement(s);
        }
      }

      let id = this.createNewLoadID();

      // Create loading element
      await this.createPreviewItem(id, series[0].name);

      // Hide the modal after preview created
      this.closeSubtractParamsModal();

      // Set itemsToProcess, 1 because only 1 request happens
      this.itemsToProcess += 1;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      // Init request body
      var payload = {
        fileKeys: series.map((series) => series.id),
        output_key: id,
      };

      // Get endpoint & add function
      var url = process.env.VUE_APP_TS_CALCULATION_API;
      url += '/subtract';

      // Add URL params
      url += '?handle_missing_units=consider_as_kWh';
      url += '&use_s3_bucket=true';
      url += '&save_result_to_s3_bucket=true';

      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) this.handleExpiredAuth();
          else throw Error('Error in fetch');
        })
        .then((json) => {
          if (json.status == 'failed') this.putElement(json);
          this.scheduleUpdateFiles();
          this.removeFromItemQueue();
        })
        .catch(() => {
          // Display modal after queue is done
          this.$set(this.modalBox, 'showAfterQueueIsDone', true);
          this.$set(
            this.modalBox.msg,
            this.modalBox.msg.length,
            'Beim Subtrahieren von ' +
              series[0].name +
              ' & ' +
              series[1].name +
              ' ist ein Fehler aufgetreten.'
          );

          this.handleItemAfterFetchError(id);
        });
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    showMergeLoadsModal() {
      this.mergeLoadsModal = {
        ...this.mergeLoadsModal,
        isMergeLoadsModalVisible: true,
        selectedItems: this.selectedSeries,
      };
    },
    closeMergeLoadsModal() {
      this.mergeLoadsModal.isMergeLoadsModalVisible = false;
    },
    async parseSelectedLoadFile(loads) {
      this.mergeLoadsModal.isLoading = true;
      try {
        // Init request body
        const formData = new FormData();
        formData.append('file', loads.file);
        formData.append('handle_status_columns', 'read_as_loadcurve');
        formData.append('translate_error_messages', 'de');

        const response = await parseLoadFile(formData);

        this.mergeSelectedLoad(loads.mode, response.data.loadCurves[0]);
      } catch (e) {
        let error = e.data.message;
        this.mergeLoadsModal.isLoading = false;
        if (e.status == HttpStatusCode.INTERNAL_SERVER_ERROR)
          error =
            'Beim Ausführen dieser Funktion ist ein Fehler aufgetreten. Bitte probieren Sie erneut oder kontaktieren Sie Ihren Administrator';
        this.showToaster(error, 'Fehlerhaft !', 'danger');
      }
    },
    async mergeSelectedLoad(mode, parsedLoad) {
      try {
        if (!this.mergeLoadsModal.selectedItems[0].hasOwnProperty('data')) {
          await this.getLoadDataById(
            this.mergeLoadsModal.selectedItems[0].id
          ).then((result) => {
            this.mergeLoadsModal.selectedItems[0] = result;
          });
        }

        const payload = {
          loadCurves: [this.mergeLoadsModal.selectedItems[0], parsedLoad],
          handle_overlapping_periods: mode,
        };
        const response = await mergeLoads(payload);
        await this.putElement(response.data);
        this.mergeLoadsModal = {
          ...this.mergeLoadsModal,
          selectedItems: [response.data],
          isMergeLoadsModalVisible: false,
        };
        this.replaceItem(response.data);
      } catch (e) {
        let error;
        if (
          e.data.message ==
          'Only loadprofiles with same frequency can be merged'
        ) {
          error =
            'Nur Zeitreihen mit der gleichen Frequenz können zusammengeführt werden.';
        } else {
          error =
            'Beim Ausführen dieser Funktion ist ein Fehler aufgetreten. Bitte probieren Sie erneut oder kontaktieren Sie Ihren Administrator';
        }
        this.showToaster(error, 'Fehlerhaft !', 'danger');
      } finally {
        this.mergeLoadsModal.isLoading = false;
      }
    },
    newID() {
      return getFlowLastId(this);
    },

    removeFromItemQueue(time = 60000) {
      setTimeout(() => {
        if (this.itemsToProcess > 0) this.itemsToProcess -= 1;
      }, time);
    },

    successEvent(file) {
      // show dummy element loading untill all files are parsed and displayed
      this.dropzoneOptions.isLoading = false;

      let id =
        this.user.username +
        '/output/' +
        this.database.name +
        '_' +
        file.renameFilename;

      // Create loading element
      this.createPreviewItem(id, file.name);

      file.previewElement.remove();
      this.hideDropZone();

      // Update files 2 min
      this.removeFromItemQueue(120000);
    },

    async createPreviewItem(id, name, currentTime = Date.now()) {
      var i = {
        id: id,
        name: name,
        created: currentTime,
        src: null,
        status: 'processing',
        ts_type: 'loadcurve',
        data: null,
      };

      // Add initial object to custom-db
      //await this.putElement(i);

      // Add loading element to this.items
      i.status = 'created';
      await this.addItemToFiles(i);
      return true;
    },

    hideLoadingIcon(f) {
      var callback = function (f, it) {
        var loaded = false;
        if (typeof it.$refs[f.id] !== 'undefined')
          loaded = it.$refs[f.id][0]._data.loaded;
        if (!loaded)
          setTimeout(() => {
            callback(f, it);
          }, 100);
        else {
          f.loading = false;
          return loaded;
        }
      };
      if (callback(f, this)) f.loading = false;
    },

    errorEvent(file, message) {
      // Remove preview
      file.previewElement.remove();

      // Init error message
      var msg;

      // Delete preview and initial object
      this.handleItemAfterFetchError(file.id);

      // Display modal after queue is done
      this.$set(this.modalBox, 'title', 'Fehler:');
      this.$set(this.modalBox, 'btnCaption', 'Ok');

      if (message === 'You can not upload any more files.') {
        let id =
          this.user.username +
          '/output/' +
          this.database.name +
          '_' +
          file.renameFilename;
        this.removeElement({ id: id }, true);
        this.modalBox.title = 'Maxanzahl erreicht';
        this.modalBox.msg = [
          'Sie können maximal ' + this.dropzoneOptions.maxFiles + ' hochladen!',
        ];
        this.modalBox.btnCaption = 'Ok!';
        this.modalBox.showAfterQueueIsDone = true;
        this.itemsToProcess = 0;
      } else {
        msg =
          'Unerwarteter Fehler! Datei ' +
          file.name +
          ' konnte nicht upgeloaded werden.\n\n';

        this.$set(this.modalBox, 'showAfterQueueIsDone', true);
        this.$set(this.modalBox.msg, this.modalBox.msg.length, msg);

        // Remove from queue
        this.itemsToProcess -= 1;
      }

      this.hideDropZone();
    },
    async removeElement(item, delFromDB) {
      this.deleteLoading = true;
      this.items.forEach((e) => {
        if (e.id === item.id) item.isLoading = true;
      });

      // Check token
      this.checkRefreshToken();

      if (delFromDB) {
        let payload = {
          keys: [item.id],
          database_name: this.database.name,
        };
        try {
          await removeCustomItem(payload);
          this.isLoading = false;
          this.scheduleUpdateFiles();
          return true;
        } catch (e) {
          throw Error(e);
        }
      }
    },

    async exportItem(item, download) {
      if (item.ts_type == 'loadcurve')
        return await this.exportLoad(item, download);
      else return await this.exportJSON(item, download);
    },

    async exportLoad(item, download) {
      // Show loading wheel
      item.isLoading = true;

      // Check token
      this.checkRefreshToken();

      // Get API params
      let url = process.env.VUE_APP_LOAD_PARSER_API;
      url += '/export-as-file?';

      const token = this.user.signInUserSession.accessToken.jwtToken;

      // Handle files from different source
      let loadCurve;
      if (item.hasOwnProperty('data')) loadCurve = item;
      else loadCurve = await this.getLoadDataById(item.id);

      loadCurve = this.removeFrontendProps(loadCurve);

      const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      };

      // Get more API params from settings
      var sections = this.appSettings.settings.sections.filter(
        (section) => section.title == 'Exportformat'
      );

      var settings = [];
      sections.forEach((element) => {
        settings = settings.concat(element.items);
      });

      settings.forEach((element) => {
        url += element.name + '=' + encodeURIComponent(element.value) + '&';
      });

      // Remove last & from url
      url = url.slice(0, -1);

      // Call API
      return fetch(url, {
        body: JSON.stringify(loadCurve),
        method: 'POST',
        headers: headers,
      })
        .then((response) => response.blob())
        .then((blob) => {
          if (download) {
            var exportName;
            if (item.name == '' || item.name == null) exportName = 'download';
            else exportName = item.name;
            this.download(blob, exportName);
          }
          item.isLoading = false;
          return blob;
        });
    },

    async exportJSON(json, download) {
      var dataStr =
        'data:application/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(json));

      if (download) {
        let link = document.createElement('a');
        let filename = json.name + '.json';
        link.setAttribute('href', dataStr);
        link.setAttribute('download', filename);
        link.click();
      } else {
        return await fetch(dataStr).then((res) => {
          return res.blob();
        });
      }
    },

    download(blob, fileName) {
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName + this.getFileExtention(blob.type);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return true;
    },

    getFileExtention(mimeType) {
      let extentions = {
        'text/csv': '.csv',
        'application/ms-excel': '.xlsx',
        'application/json': '.json',
      };
      return extentions[mimeType];
    },

    goTo(id) {
      this.$router.push({
        path: '/',
        query: { section: 'data', database: this.database.name, item: id },
      });
    },

    async goToLoadProfile(id) {
      let loadCurve = await this.getLoadDataById(id);
      this.settingsIsVisible = false;
      this.selectedLoadProfile = loadCurve;
      this.isProfileDetailsVisible = true;
    },

    formatDate(value) {
      if (!value) return 'Nicht vorhanden';
      var temp = new Date(parseInt(value));
      return temp.toLocaleDateString('de-DE', this.dateOptions);
    },

    formatDatetime(value) {
      let timestamp = new Date(parseInt(value));
      let d = timestamp.toLocaleDateString('de-DE', this.dateOptions);
      let t = timestamp.toLocaleTimeString('de-DE').slice(0, -3);
      return d + ' ' + t;
    },
    renderDateRange(start, end) {
      return start || end
        ? `${this.formatDate(start)} - ${this.formatDate(end)}`
        : 'Nicht vorhanden';
    },
    getFrontEndNameFormat(name) {
      if (name.includes('_report_')) {
        let regex = /^_report_{1}[0-9]{13}_{1}/gm;
        return name.replace(regex, '_report_');
      } else {
        let regex = /^[0-9]{13}_{1}/gm;
        return name.replace(regex, '');
      }
    },

    shareItem(item) {
      if (item.ts_type == 'loadcurve') {
        this.shareSetting.artefact = 'Lastgang';
        this.shareSetting.description =
          'Der Empfänger wird eine E-Mail mit dem Lastgang als Anhang empfangen.';
      } else {
        this.shareSetting.artefact = 'Metadaten';
        this.shareSetting.description =
          'Der Empfänger wird eine E-Mail mit den Metadaten als Anhang empfangen.';
      }

      this.exportItem(item).then((b) => {
        this.shareSetting.attachment = b;
        this.shareSetting.isShareModalVisible = true;
      });
    },

    shareselectedItems() {
      this.shareSetting.artefact = 'Lastgänge';
      this.shareSetting.description =
        'Der Empfänger wird eine E-Mail mit den Lastgängen als Anhang empfangen.';
      let files = [];
      this.selectedElements.forEach((f, index) => {
        this.exportItem(f).then((blob) => {
          files.push({
            name: f.name + this.getFileExtention(blob.type),
            blob: blob,
          });
          if (index === this.selectedElements.length - 1) {
            this.zipselectedItems(files).then((zipFile) => {
              this.shareSetting.attachment = zipFile;
              this.shareSetting.isShareModalVisible = true;
            });
          }
        });
      });
    },

    zipselectedItems(items) {
      // Assign new zip object
      let zip = new JSZip();

      // Loop through the filelist to get each filename and pass each file to zip object
      for (let item of items) {
        let filename = item.name;
        zip.file(filename, item.blob);
      }

      // Generate the complete zip file
      return zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: {
          level: 9,
        },
      });
    },

    closeModal() {
      this.shareSetting.isShareModalVisible = false;
    },

    duplicateElement: function (element) {
      const item = element;
      const duplicatePreviewId = this.createNewLoadID(item.id);
      this.createPreviewItem(duplicatePreviewId, item.name);
      let url = process.env.VUE_APP_DATA_API;
      url += '/timeseries/duplicate/';
      url += encodeURIComponent(item.id);
      this.scrollToTopOfLoadProfileList();

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('Content-Type', 'application/json');

      return fetch(encodeURI(url), {
        headers: myHeaders,
        method: 'PUT',
      })
        .then((response) => {
          if (response.status == 200) {
            return response.json();
          } else if (response.status == 401) this.handleExpiredAuth();
          else throw Error('Error in fetch');
        })
        .then(async (duplicateItemJsonResponse) => {
          this.items = this.items.map((item) =>
            item.id == duplicatePreviewId
              ? { ...item, id: duplicateItemJsonResponse.key }
              : { ...item }
          );
          this.scheduleUpdateFiles();
        })
        .catch(() => {
          // Display modal after queue is done
          item.isLoading = false;
          this.$set(this.modalBox, 'showAfterQueueIsDone', true);
          this.$set(
            this.modalBox.msg,
            this.modalBox.msg.length,
            'Beim duplizieren der Zeitreihe ' +
              item.name +
              ' ist ein Fehler aufgetreten.'
          );

          this.handleItemAfterFetchError(item.id);
        });
    },

    alertFunctionNA: function () {
      this.modalBox.title = 'Sorry...';
      this.modalBox.msg =
        'Diese Funktion befindet sich noch in der Entwicklung und steht im aktuellen Release noch nicht zur Verfügung. ';
      this.modalBox.btnCaption = 'Alles klar!';
      this.modalBox.showAfterQueueIsDone = true;
    },

    alertMaxFilesReached() {
      this.modalBox.title = 'Maxanzahl erreicht';
      this.modalBox.msg = [
        'Sie können maximal ' + this.dropzoneOptions.maxFiles + ' hochladen!',
      ];
      this.modalBox.btnCaption = 'Ok!';
      this.modalBox.showAfterQueueIsDone = true;
    },

    alertErrorInSlp() {
      this.modalBox.title = 'Fehler beim Erstellen des Profils';
      this.modalBox.msg = [
        'Beim Erstellen des Profils ist ein Fehler aufgetreten.',
      ];
      this.modalBox.btnCaption = 'Alles klar!';
      this.modalBox.showAfterQueueIsDone = true;
    },
    hideAddFilter() {
      if (this.isAddFilterVisible) {
        this.removeEmptyFilter();
        this.isAddFilterVisible = false;
        this.activeFilter = null;
      }
    },
    showAddFilter() {
      if (this.isAddFilterVisible) {
        this.removeEmptyFilter();
        this.isAddFilterVisible = false;
        this.activeFilter = null;
        return null;
      }
      const activeFilterData = {
        id: this.newID(),
        caption: null,
        property: null,
        opperand: null,
        value: null,
      };
      this.activeFilter = activeFilterData;
      this.isAddFilterVisible = true;
      this.$set(this.filters, this.filters.length, activeFilterData);
    },
    addFilterCaption(caption) {
      this.activeFilter.property = caption;
      loadProfileDataSchema.forEach((data) => {
        if (data.name == this.activeFilter.property) {
          this.activeFilter.caption = data.label;
          this.activeFilter.type = data.type;
          this.activeFilter.options = data.options;
          this.activeFilter.value = '';
        }
      });
    },
    showEditFilter(filter) {
      this.activeFilter = filter;
      this.isClickOutsideDelayed = true;
      this.isEditFilterVisible = true;
      setTimeout(() => (this.isClickOutsideDelayed = false), 300);
    },
    hideEditFilter() {
      if (this.isEditFilterVisible && !this.isClickOutsideDelayed) {
        this.isEditFilterVisible = false;
        this.activeFilter = null;
      }
    },
    sortItemsAsSchemaOrder(items) {
      // Order items
      if (this.database.type === 'loadprofile') {
        this.itemOrder = loadProfileDataSchema.map((data) => data.name);
      } else {
        this.itemOrder = this.dataSchema.map((data) => data.name);
      }
      return JSON.parse(JSON.stringify(items, this.itemOrder));
    },
    removeFilter(id) {
      this.filters = this.filters.filter((filter) => filter.id != id);
    },
    removeEmptyFilter() {
      this.filters = this.filters.filter((filter) => filter.property != null);
    },
    formatLabel(l) {
      if (l.length > 25) return l.slice(0, 25) + '...';
      else return l;
    },
    hideModalBox() {
      // Hide loading after user confirm errors
      this.$set(this.dropzoneOptions, 'isLoading', false);

      // Reset modal params & hide
      this.$set(this.modalBox, 'title', '');
      this.$set(this.modalBox, 'msg', []);
      this.$set(this.modalBox, 'showAfterQueueIsDone', false);
      this.$set(this.modalBox, 'showModalBox', false);
    },

    hideProfileDetails() {
      this.isProfileDetailsVisible = false;
      this.selectedLoadProfile = null;
    },

    toggleLoadDetails() {
      this.isProfileDetailsVisible = false;

      this.$router.push({
        path: '/',
        query: { section: 'data', database: this.database.name },
      });

      this.selectedLoadProfile = null;
    },

    maxFileCountReached() {
      this.alertMaxFilesReached();
    },

    showSlpProfile() {
      this.isSlpProfileVisible = true;

      // Check token
      this.checkRefreshToken();
    },

    async showComparator() {
      this.isLoading = true;
      for (let s of this.selectedSeries) {
        if (!s.hasOwnProperty('data')) {
          await this.getLoadDataById(s.id).then((result) => {
            this.replaceItem(result);
          });
        }
      }
      this.isLoading = false;
      this.isComparatorVisible = true;
    },

    replaceItem(item) {
      let index = this.items.findIndex((x) => x.id == item.id);
      // Put results and add selected and isLoading attributes
      item.isLoading = false;
      this.items.splice(index, 1, item);
    },
    closeComparator() {
      this.isComparatorVisible = false;
    },

    showWeather() {
      this.isWeatherVisible = !this.isWeatherVisible;
      this.checkRefreshToken();
    },

    // TODO: simplify
    showApiOptions(position) {
      if (position == 'left') {
        switch (this.appSettings.app) {
          case 'slp-generator':
            this.showSlpProfile();
            break;
          case 'weather':
            this.showWeather();
            break;
          case 'loadparser':
          case 'edm':
          case 'default':
            this.showSlpProfile();
            break;
        }
      } else if (position == 'right') {
        switch (this.appSettings.app) {
          case 'loadparser':
          case 'edm':
          case 'default':
            this.toggleUpload();
            break;
        }
      }
    },

    getImgUrl(pic) {
      return require('../assets/' + pic);
    },

    async closeSlpProfile(profile) {
      if (profile != null) {
        // Add item to loading queue
        this.itemsToProcess += 1;

        this.hideDropZone();

        await this.putElement(profile);
        this.isSlpProfileVisible = false;
        this.removeFromItemQueue();
      } else {
        this.isSlpProfileVisible = false;
        this.isLoading = false;

        // Show error
        if (profile == 'showError') {
          profile = null;
          this.alertErrorInSlp();
        }
      }
    },

    closeWeather(profile) {
      if (profile != null) {
        profile.id = new Date().getUTCMilliseconds();
        profile.supplyPoint = {
          name: null,
          meloId: null,
          address: null,
        };
        this.addWeatherFile(profile);
        this.isWeatherVisible = false;
      } else this.isWeatherVisible = false;
    },

    getZoom() {
      return this.zoom / 100;
    },

    addWeatherFile(weatherData) {
      const fileData = {
        id: weatherData.id,
        name: 'Wetterdaten ID:' + weatherData.id,
        selected: false,
        loading: false,
        dataForExcel: null,
      };
      this.$set(this.items, this.items.length, fileData);
      fileData.series = [];
      fileData.series[0] = weatherData;
      this.hideDropZone();
      this.hideLoadingIcon(fileData);
    },

    async refreshSession() {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(
          currentSession.refreshToken,
          (err, session) => {
            // Replace user with new token
            let user = this.user;
            user.signInUserSession = session;

            // Set updated user
            Store.commit('setUser', user);

            // Set new refresh time
            this.lastTokenRefresh = Date.now();

            return session;
          }
        );
      } catch (e) {
        // Verification failed, log out
        Store.commit('setUser', null);

        return null;
      }
    },

    refreshItems() {
      this.isRefreshing = true;
      this.updateItems();
    },

    async updateItems() {
      // Check token before api call
      this.checkRefreshToken();

      // Show dummy element for loading
      if (!this.isRefreshing && this.itemsToProcess < 0)
        this.dropzoneOptions.isLoading = true;

      var url = process.env.VUE_APP_DATA_API + '/user-tables/';
      url += this.database.name + '/items';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      fetch(url, { headers: myHeaders, method: 'GET' })
        .then(async (response) => {
          if (response.status == 401)
            throw new Error('Access Token has expired');
          else return response.json();
        })
        .then(async (els) => {
          // Handle new items
          els.forEach((e) => {
            let index = this.items.findIndex((x) => x.id == e.id);

            // Add frontend props
            e.isLoading = false;

            // Add to this.items if not found
            if (index == -1) {
              this.$set(this.items, this.items.length, e);

              // If item is newer than in this.items update
            } else if (this.items[index].created < e.created) {
              this.items.splice(index, 1, e);
            }

            // Update file in load-details
            if (this.showProfileDetails) {
              if (e.id == this.selectedLoadProfile.id)
                this.selectedLoadProfile = JSON.parse(JSON.stringify(e));
            }
          });

          // Remove items with status:error if they're not in DB
          this.items.forEach((e) => {
            let index = els.findIndex((x) => x.id == e.id);

            if (index == -1 && e.created < Date.now() - 30000) {
              this.items = this.items.filter((item) => item.id != e.id);
            }
          });

          // hide loading wheel after page is created
          this.isLoading = false;

          // hide loading dummy if all files are success
          this.dropzoneOptions.isLoading = self.isItemLoading;

          // hide refreshing with delay for better usabilify
          setTimeout(() => (this.isRefreshing = false), 1200);
        })
        .catch((e) => {
          if (e == 'Error: Access Token has expired') {
            this.handleExpiredAuth();
          }
          this.isRefreshing = false;
        });
    },

    saveFileFromProfileDetails(loadCurve) {
      var url = process.env.VUE_APP_DATA_API + '/files';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('Content-Type', 'application/json');

      // Remove frontend props
      loadCurve = this.removeFrontendProps(loadCurve);

      // Update created
      loadCurve.created = Date.now();

      let body = {
        file_content: loadCurve,
      };

      return fetch(encodeURI(url), {
        body: JSON.stringify(body),
        headers: myHeaders,
        method: 'PUT',
      })
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.scheduleUpdateFiles();
            return true;
          } else if (response.status == 401) this.handleExpiredAuth();
          else throw Error('Error in fetch');
        })
        .catch(() => {
          this.isLoading = false;
          // Display modal after queue is done
          this.$set(this.modalBox, 'showAfterQueueIsDone', true);
          this.$set(
            this.modalBox.msg,
            this.modalBox.msg.length,
            'Beim speichern der Zeitreihe ' +
              loadCurve.name +
              ' ist ein Fehler aufgetreten.'
          );

          this.handleItemAfterFetchError(loadCurve.id);
        });
    },

    async addItemToFiles(f) {
      // if in any case, the id already exists - overwrite it with the new file
      if (
        this.items.indexOf(this.items.filter((item) => item.id == f.id)[0]) !=
        -1
      ) {
        this.$set(
          this.items,
          this.items.indexOf(this.items.filter((item) => item.id == f.id)[0]),
          f
        );
      } else this.$set(this.items, this.items.length, f);

      return true;
    },

    // Put metadata to DB
    async updateMetadata(item) {
      var url = process.env.VUE_APP_DATA_API + '/files';

      // Remove selected
      let itemCopy = JSON.parse(JSON.stringify(item));
      delete itemCopy.selected;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      var payload = {
        file_content: itemCopy,
        database_name: this.database.name,
      };

      fetch(url, {
        headers: myHeaders,
        body: JSON.stringify(payload),
        method: 'PUT',
      }).then((response) => {
        if (response.status == 401) {
          this.handleExpiredAuth();
        } else {
          //TODO: Maybe add waiter in backend before return
          setTimeout(() => this.scheduleUpdateFiles(), 1000);
        }
      });
    },

    closeHedgeParamsModal() {
      this.$set(this.hedgeParamsModal, 'isHedgeParamsModalVisible', false);
    },

    closeSumParamsModal() {
      this.$set(this.sumParamsModal, 'isSumParamsModalVisible', false);
    },

    showMetadata(item) {
      this.$set(
        this.reportViewer,
        'title',
        this.getNameWithoutTimestamp(item.name)
      );
      this.$set(this.reportViewer, 'json', item);
      this.$set(this.reportViewer, 'btnCaption', 'Ok');
      this.$set(this.reportViewer, 'isReportViewerVisible', true);
    },

    highlightJsonErr() {
      var keys = document.getElementsByClassName('vjs-key');
      for (let k in keys) {
        if (keys[k].innerText == '"error":') {
          keys[k].style = 'color: rgb(255, 51, 102)';
          keys[k].nextElementSibling.children[0].style =
            'color:rgb(255, 51, 102)';
        }
      }
    },

    hideReportViewer() {
      this.reportViewer.isReportViewerVisible =
        !this.reportViewer.isReportViewerVisible;
    },

    checkRefreshToken() {
      if ((Date.now() - this.lastTokenRefresh) / 60000 > 15)
        this.refreshSession();
    },

    getNameWithoutTimestamp(name) {
      let regex = /^[0-9]{13}_{1}/gm;
      return name.split(regex)[1];
    },

    showMaxFilesReached(count, item) {
      this.$set(this.modalBox, 'showAfterQueueIsDone', true);
      this.$set(
        this.modalBox.msg,
        this.modalBox.msg.length,
        'Bitte wählen Sie maximal ' +
          count +
          ' ' +
          item +
          ' aus, um diese Funktion auszuführen.'
      );
      this.modalBox.showAfterQueueIsDone = true;
    },

    async runAction(id, itemID) {
      if (itemID) this.isActionDropDownLoading = { actionID: id, itemID };
      try {
        this.selectedElements[0]
          ? (this.selectedElements[0].loading = true)
          : null;

        const params = `?id=${id}&databaseid=${this.database.name}&model=${
          this.elOnHoverIdx ? this.elOnHoverIdx : this.selectedElements[0].id
        }`;
        const response = await runFlowById(params);

        if (response && response.status === 200 && response.data) {
          this.selectedElements[0]
            ? (this.selectedElements[0].loading = false)
            : null;
          this.$set(this.htmlViewerModal, 'myHtml', response.data);
          this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', true);
          this.isActionDropDownLoading = { actionID: null, itemID: null };
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log({ error });
        this.isActionDropDownLoading = { actionID: null, itemID: null };
      }
    },

    async createNewAction() {
      let id = this.newID();
      let rslt = await this.$store.dispatch('createNewFlow', {
        id: id,
        type: 'action',
        dataType: 'loadprofile',
        fileKey: this.elOnHoverIdx
          ? this.elOnHoverIdx
          : this.selectedSeries[0].id,
        tableID: this.database.name,
      });

      if (rslt == 'Access Token has expired') {
        this.handleExpiredAuth();
      } else {
        this.$router.push({
          path: '/',
          query: {
            section: 'process-designer',
            process: id,
          },
        });
      }
    },

    async getAllItems() {
      try {
        const response = await getUserTabels(this.database.name);
        // Delay to prevent "no item screen" before rendering items
        setTimeout(() => {
          this.isLoading = false;
        }, 250);
        // Add selected to elements
        response.data.forEach((e) => {
          e.selected = false;
          e.isLoading = false;
          if (
            e.tags &&
            e.tags[0] &&
            !this.tagsFilterOptions.includes(e.tags[0].name)
          )
            this.tagsFilterOptions.push(e.tags[0].name);
          return e;
        });
        this.items = response.data;
        this.sortItems();
        this.isLoading = false;
        return true;
      } catch (e) {
        this.isLoading = false;
      }
    },

    handleExpiredAuth() {
      localStorage.clear(),
        this.$router.push({
          name: 'auth',
          params: { message: 'Sitzung abgelaufen' },
        });
    },

    async getLoadDataById(id) {
      // this.isLoading = true;
      this.deleteLoading = true;
      var url = process.env.VUE_APP_DATA_API + '/files/';
      url += encodeURIComponent(id);

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return await fetch(encodeURI(url), {
        headers: myHeaders,
        method: 'GET',
      })
        .then((response) => {
          if (response.status == 401)
            throw new Error('Access Token has expired');
          else
            return response.json().then((json) => {
              return json;
            });
        })
        .catch((e) => {
          this.isLoading = false;
          if (e == 'Error: Access Token has expired') {
            this.handleExpiredAuth();
          }
        });
    },

    removeFrontendProps(item) {
      var propsToDelete = ['selected', 'isLoading'];
      let itemCopy = JSON.parse(JSON.stringify(item));

      for (let prop of propsToDelete) {
        if (itemCopy.hasOwnProperty(prop)) {
          delete itemCopy[prop];
        }
      }
      return itemCopy;
    },

    scheduleUpdateFiles() {
      let initRefreshTime = 850;
      let refreshTimes = 16;
      let count = 1;

      for (let i of this.refreshSettings.que) {
        clearTimeout(i);
      }

      // Der timeout ist nur zum sichergehen, das alle timeouts gecleart wurden, vllt.
      // könnte man nachher mit then oder await machen.
      setTimeout(() => {
        this.refreshSettings.que = [];
        let currentRefreshTime = initRefreshTime;
        while (count < refreshTimes) {
          let factor;
          if (count < 4) factor = 2;
          else if (count < 7) factor = 1.5;
          else factor = 1.15;
          currentRefreshTime = currentRefreshTime *= factor;

          let refreshTimer = setTimeout(() => {
            this.updateItems();
          }, currentRefreshTime);

          this.refreshSettings.que.push(refreshTimer);
          count += 1;
        }
      }, 500);
    },

    createNewLoadID(id = null) {
      let oldTS, newID;
      const newTS = new Date().getTime();
      if (id != null) {
        oldTS = id.split('_')[id.split('_').length - 1];
        newID = id.replace(oldTS, newTS);
      } else {
        oldTS =
          this.selectedSeries[0].id.split('_')[
            this.selectedSeries[0].id.split('_').length - 1
          ];
        newID = this.selectedSeries[0].id.replace(oldTS, newTS);
      }

      return newID;
    },

    sortItems() {
      this.items.sort((item_a, item_b) => {
        // Get timestamps
        let a = item_a.created;
        let b = item_b.created;

        // Compare
        return a < b ? 1 : b < a ? -1 : 0;
      });
    },

    async handleItemAfterFetchError(id) {
      // Set error status & clear interval before remove
      this.itemsToProcess -= 1;
      clearTimeout(this.refreshTimer);

      // Wait for the last update
      setTimeout(async () => {
        await this.removeElement({ id: id }, true);

        // If item still present, set error status
        let index = this.items.findIndex((e) => e.id == id);
        if (index != -1) this.items[index].status = 'error';
      }, 200);
    },
    openChangeUnit(unit, load) {
      this.unitValues.new = unit;
      this.unitValues.old = load.unit;
      this.unitValues.lastOpnedLoad = load;

      this.loadWaitingForUnitChange = load;
      this.isChangeUnitModalOpen = true;
    },
    closeUnitModal() {
      this.isChangeUnitModalOpen = false;
      this.loadWaitingForUnitChange = null;
    },
    async addUnitToLoad() {
      this.loadWaitingForUnitChange.loading = true;
      this.isChangeUnitModalOpen = false;
      this.unitValues.lastOpnedLoad.isLoading = true;
      this.loadWaitingForUnitChange.unit = this.unitValues.new;
      await this.putElement(this.loadWaitingForUnitChange, true);
      this.unitValues.lastOpnedLoad.unit = this.unitValues.new;
      this.unitValues.lastOpnedLoad.isLoading = false;
      this.loadWaitingForUnitChange = null;
    },
    async convertLoad() {
      this.loadWaitingForUnitChange.loading = true;
      this.isChangeUnitModalOpen = false;
      this.unitValues.lastOpnedLoad.isLoading = true;

      const loadprofile = await this.getLoadDataById(
        this.loadWaitingForUnitChange.id
      );
      loadprofile.unit = this.unitValues.old;

      var url = process.env.VUE_APP_TS_CALCULATION_API;
      url += '/convert-unit';
      url += '?output_unit=' + this.unitValues.new;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      const payload = {
        loadCurve: loadprofile,
      };

      return fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'POST',
      })
        .then((response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401) {
            throw new Error('Access Token has expired');
          } else throw new Error('CORS');
        })
        .then((json) => {
          this.loadWaitingForUnitChange = null;

          // save converted load
          this.putElement(json);
        })
        .catch((e) => {
          //TODO: If error CORS show modal (emit in parent)
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          } else {
            this.loadWaitingForUnitChange.loading = true;
          }
        });
    },
    async handleItemsAtCreated() {
      const state = this.$store.state.databaseItems;
      const name = this.database.name;
      if (state.hasOwnProperty(name)) {
        this.items = state[name];
        this.sortItems();
        this.isLoading = false;
        this.redrawChart = !this.redrawChart;
        if (this.seriesCount > 0) this.filter = 'timeseries';
        return true;
      } else {
        this.getAllItems().then(() => {
          if (this.seriesCount > 0) this.filter = 'timeseries';
          if (this.itemID && this.isActiveDB) {
            this.goToLoadProfile(this.itemID);
          }
          return true;
        });
      }
    },
    getQuantityUnit(item) {
      let hasQuantity =
        item.hasOwnProperty('quantity') &&
        typeof item.quantity == 'object' &&
        item.quantity !== null;
      if (hasQuantity) {
        if (item.quantity.hasOwnProperty('unit')) return item.quantity.unit;
        else return '';
      } else return '';
    },
    checkFilterInput(filterType) {
      if (
        filterType != 'radio' &&
        filterType != 'checkbox' &&
        filterType != 'timestamp'
      )
        return 'text';
      if (filterType == 'radio' || filterType == 'checkbox') return 'selectBox';
      if (filterType == 'timestamp') return 'datetime';
      return false;
    },
    showFilterOperatorOption(operatorVisibility, filterType) {
      if (operatorVisibility.includes(filterType)) return true;
      return false;
    },
    selectFilterItemsInCustomRange(startingIndex, endingIndex) {
      this.customFilter.forEach((filteredItem, index) =>
        index >= startingIndex && index <= endingIndex
          ? this.selectItem(filteredItem.id)
          : ''
      );
    },
    selectAllItemsBetweenShiftPressed(currentItemSelectedIndex, item) {
      const newItemSelectionIndex = this.customFilter.findIndex(
        (filteredItem) => filteredItem.id == item.id
      );

      currentItemSelectedIndex < newItemSelectionIndex
        ? this.selectFilterItemsInCustomRange(
            currentItemSelectedIndex,
            newItemSelectionIndex
          )
        : this.selectFilterItemsInCustomRange(
            newItemSelectionIndex,
            currentItemSelectedIndex
          );
    },
    toggleView(view) {
      this.zoom = 70;
      this.view = view;
      this.isScrollToTopButtonVisible = false;
    },
    isSelectedSeriesTimePeriodValid() {
      const diffrence = this.selectedSeries.reduce((acc, cur) => {
        if (!acc.start || acc.start > cur.start) acc.start = cur.start;

        if (!acc.end || acc.end < cur.end) acc.end = cur.end;
        return acc;
      }, {});
      if (
        moment(diffrence.start).add(4, 'year').isBefore(moment(diffrence.end))
      ) {
        return false;
      } else return true;
    },
    openTimePeriodValidModal() {
      this.$set(this.modalBox, 'showAfterQueueIsDone', false);
      this.$set(
        this.modalBox.msg,
        this.modalBox.msg.length,
        'Die ausgewählten Lastgänge überschreiten den erlaubten Zeitraum von 4 Jahren für das ausführen dieser Operation.'
      );
      this.$set(this.modalBox, 'showModalBox', true);
    },
    scrollToTopOfLoadProfileList() {
      this.$refs.loadlist.scrollTo({ top: 0, behavior: 'smooth' });
    },
    isSelectedItem(id) {
      return this.selectedItemIds.includes(id);
    },
    selectItem(id) {
      if (!this.isSelectedItem(id)) this.selectedItemIds.push(id);
    },
    removeSelectedFilteredItems(id) {
      const index = this.selectedItemIds.findIndex(
        (selectedId) => selectedId == id
      );
      if (index > -1) this.selectedItemIds.splice(index, 1);
    },
    toggleSeletedItem(id) {
      const index = this.selectedItemIds.findIndex(
        (selectedId) => selectedId == id
      );
      if (index > -1) {
        this.selectedItemIds.splice(index, 1);
      } else {
        this.selectedItemIds.push(id);
      }
    },
    addFilterOpperand(opperand, label) {
      this.activeFilter.opperand = opperand;
      this.activeFilter.opperandLabel = label;
      this.$forceUpdate();
    },
    addFilterValue(value) {
      this.activeFilter.value = value;
    },
    toggleListViewZIndex(value) {
      this.currentOpenListViewWattDropdown = value;
    },
    isTableIdArray(tableID) {
      if (typeof tableID === 'string') {
        return false;
      }

      if (Array.isArray(tableID)) {
        return true;
      }

      return null;
    },
    async calculateMetaData(load) {
      try {
        const payload = {
          loadCurve: JSON.parse(JSON.stringify(load)),
        };
        const calculateMetadataResponse = await calculateMetaDataApi(payload);
        if (calculateMetadataResponse.status == 200)
          return calculateMetadataResponse.data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('error :>> ', error);
      }
    },
  },
  created() {
    this.listActionDropdownOptions = [
      // {
      //   name: 'Neue Aktion hinzufügen',
      //   isShowAction: () =>
      //     this.selectedSeriesCount == 1 && this.hasAddNewActionPermission,
      //   eventName: 'click',
      //   eventHandler: () => this.createNewAction(),
      //   icon: 'plusIcon',
      // },
      {
        name: 'Summieren',
        isShowAction: () => this.selectedSeriesCount >= 2,
        eventName: 'click',
        eventHandler: () =>
          this.selectedSeriesCount > 50
            ? this.showMaxFilesReached(50, 'Lastgänge')
            : this.checkLoadsBeforeSum(),
      },
      {
        name: 'Mittelwert ermitteln',
        isShowAction: () => false && this.selectedSeriesCount >= 2,
        eventName: 'click',
        eventHandler: () => this.avgSelectedLoads(),
      },
      {
        name: 'Subtrahieren',
        isShowAction: () => this.selectedSeriesCount == 2,
        eventName: 'click',
        eventHandler: () => this.showSubtractParamsModal(),
      },
      {
        name: 'Hedgen',
        isShowAction: () => false,
        eventName: 'click',
        eventHandler: () => this.showHedgeParamsModal(),
      },
      {
        name: 'Ausrollen',
        isShowAction: () => false,
        eventName: 'click',
        eventHandler: () => this.showForecastParamsModalCalendar(),
      },
      {
        name: 'Ausrollen Gas',
        isShowAction: () => false,
        eventName: 'click',
        eventHandler: () => this.showForecastParamsModalTemp(),
      },
      {
        name: 'Vergleichen',
        isShowAction: () => this.selectedSeriesCount >= 2,
        eventName: 'click',
        eventHandler: () => this.showComparator(),
      },
      {
        name: 'Meine Aktionen',
        isShowAction: () =>
          this.selectedSeriesCount < 2 && this.actionList.length > 0,
        eventName: 'mouseleave',
        eventHandler: () => this.toggleActionsDropdown(),
      },
    ];
  },
  async mounted() {
    // Display the loading spinner untill file handling is done
    this.isLoading = true;

    setTimeout(async () => {
      await this.handleItemsAtCreated();
      // Add scroll listener
    }, 50);

    // Initiate time for token refresh
    this.lastTokenRefresh = Date.now();

    // Initiate last refresh
    const currentDate = new Date();
    const now = currentDate.getTime();
    this.refreshSettings.lastRefresh = now;
  },
  beforeDestroy() {
    // Clear the update interval, if user switches components
    clearInterval(this.fileUpdateInterval);
    this.$store.commit('databaseItems', {
      name: this.database.name,
      items: this.items,
    });
  },
  watch: {
    offsetTop() {
      this.getLoadDataForItemsInViewPoint();
    },
    itemsToProcess(val) {
      if (val > 0) {
        this.scheduleUpdateFiles();
      } else {
        //this.refreshSettings.queue = 0;
        //this.refreshSettings.interval = 500;
        //clearTimeout(this.refreshTimer);
        //this.refreshTimer = null
      }
    },
    'appSettings.settings': {
      deep: true,
      handler(settings) {
        if (this.user && this.user.username)
          localStorage.setItem(
            this.user.username + '.userSettings',
            JSON.stringify(settings)
          );
      },
    },
    'items.length'() {
      this.sortItems();
    },

    // Toggle loadProfiles
    itemID(id) {
      if (this.itemID && this.isActiveDB) this.goToLoadProfile(id);
      // When user uses browser back button
      else if (this.isActiveDB) this.toggleLoadDetails();
    },

    isActiveDB(bool) {
      if (bool === true) {
        this.getAllItems();
      }
    },
  },
  updated() {
    this.getLoadDataForItemsInViewPoint();
  },
  computed: {
    ...mapGetters({ getAllFlows: 'getAllFlows' }),
    user() {
      return Store.state.user;
    },
    hasAddNewActionPermission() {
      return this.$store.state.addNewFlowPermission;
    },
    noData() {
      return this.items.length < 1;
    },
    isActiveDB() {
      return this.activeDatabase == this.database.name;
    },
    isZoomVisible() {
      return !this.noData && !this.uploadActive && !this.isAddOptionsVisible;
    },
    isModalVisible() {
      return this.itemsToProcess < 1 && this.modalBox.showAfterQueueIsDone;
    },
    appSettings() {
      return Store.state.appSettings;
    },
    timeFrameFilter() {
      return new Date().getTime() - this.filterTime;
    },
    timeFilteredFileIds() {
      const filteredFiles = this.items
        .filter((e) => e.created > this.timeFrameFilter)
        .map((item) => item.id);

      return filteredFiles;
    },
    selectedElements() {
      return this.filteredItems.filter((i) => this.isSelectedItem(i.id));
    },
    selectedSeries() {
      return this.selectedElements.filter(
        (i) => i.status == 'success' && i.ts_type == 'loadcurve'
      );
    },
    selectedSeriesCount() {
      return this.selectedSeries.length;
    },
    seriesCount() {
      return this.items.filter((i) => i.ts_type == 'loadcurve').length;
    },
    isSeriesSelected() {
      return this.selectedSeriesCount > 0;
    },
    selectedLoadsWithoutUnit() {
      return this.selectedSeries.filter((s) => !s.unit);
    },
    isLoadWithoutUnitSelected() {
      return this.selectedLoadsWithoutUnit.length > 0;
    },
    allItemsSelected() {
      return this.selectedElements.length == this.filteredItems.length;
    },
    isItemLoading() {
      let loadingStatus = ['waiting', 'created', 'processing'];
      return (
        this.items.filter((i) => loadingStatus.includes(i.status)).length > 0
      );
    },
    showGroupAction() {
      if (this.isNewDataTypeModalVisible) {
        return false;
      } else
        return (
          this.filteredItems.filter((i) => this.isSelectedItem(i.id)).length > 0
        );
    },

    actionList() {
      // TODO: Remove timeseries statement when all flows in database updated to loadprofile
      return this.getAllFlows.filter((element) => {
        if (
          element.type === 'action' &&
          (element.dataType === 'timeseries' ||
            element.dataType === 'loadprofile')
        ) {
          if (!element.table_id) {
            return true; // Filter if table_id is null or not exists
          } else if (Array.isArray(element.table_id)) {
            return element.table_id.includes(this.database.name.trim());
          } else if (typeof element.table_id === 'string') {
            return element.table_id === this.database.name.trim();
          }
        }
        return false;
      });
    },

    actionsDropdownHeight() {
      return 151 - this.actionList.length * 36;
    },
    parseSettingsAsObject() {
      var settingsAsObjects = {};

      this.appSettings.settings.sections.forEach((part) => {
        part.items.forEach((e) => {
          settingsAsObjects[e.name] = e.value;
        });
      });
      return settingsAsObjects;
    },
    loadProfileFilterSchema() {
      return this.tagsFilterOptions.length
        ? [
            ...loadProfileDataSchema,
            {
              id: 1673523642585,
              default: false,
              highlight: false,
              options: this.tagsFilterOptions,
              structure: {
                tab: 0,
                row: 0,
                col: 0,
              },
              attributes: {
                required: false,
                disabled: false,
              },
              name: 'tags[0].name',
              label: 'Tags',
              placeholder: '',
              type: 'radio',
              value: '',
              layoutItem: false,
            },
          ]
        : loadProfileDataSchema;
    },
    dataSchema() {
      return this.loadProfileFilterSchema.filter(
        (item) => item.label != 'Konvention'
      );
    },
    latestCreatedAt() {
      return Math.max.apply(
        Math,
        this.items.map((item) => {
          //TODO: Refactor - this is a workaround because some items dont have created yet
          if (item.hasOwnProperty('created')) {
            return item.created;
          } else return 0;
        })
      );
    },
    filteredItems() {
      // Filter using conditions
      let filteredItems = JSON.parse(JSON.stringify(this.items));
      if (this.filter != 'unset') {
        let filter;
        let filterString = 'false ';
        for (
          let i = 0;
          i < this.filterOptions[this.filter].condition.length;
          i++
        ) {
          filter = this.filterOptions[this.filter].condition[i];
          filterString +=
            '|| String(i.' +
            filter['attr'] +
            ') ' +
            filter['operand'] +
            " '" +
            filter['value'] +
            "'";
        }
        // Filter the items based on the condition
        // Use eval to create the filter statment
        // "i" ist used in filterString

        // eslint-disable-next-line no-unused-vars
        filteredItems = this.items.filter((i) => {
          if (!eval(filterString)) {
            this.removeSelectedFilteredItems(i.id);
            return false;
          } else return true;
        });
      }

      // Filter using search string
      if (this.search != '') {
        filteredItems = this.items.filter((i) => {
          if (
            i.hasOwnProperty('name') &&
            i.name.toLowerCase().includes(this.search.toLowerCase())
          ) {
            return true;
          } else {
            this.removeSelectedFilteredItems(i.id);
            return false;
          }
        });
      }

      // Filter the items using the time filter
      if (this.filterTime != 9999999999999)
        filteredItems = filteredItems.filter((i) => {
          if (this.timeFilteredFileIds.includes(i.id)) {
            return true;
          } else {
            this.removeSelectedFilteredItems(i.id);
            return false;
          }
        });

      return filteredItems;
    },
    customFilter() {
      const filterItems = this.filteredItems;
      if (this.filters.length <= 0) return filterItems;
      else {
        // Get only filters that can be interpreted
        let readyFilters = [];
        for (let filter of this.filters) {
          if (filter.property && filter.value && filter.opperand) {
            if (filter.type == 'timestamp')
              readyFilters.push({
                ...filter,
                value: moment(filter.value).valueOf(),
              });
            else readyFilters.push(filter);
          }
        }
        if (readyFilters.length > 0) {
          let filterString = '';
          for (let f of readyFilters) {
            // Simple type filter
            if (f.opperand == '==' || f.opperand == '!=') {
              filterString +=
                'String(e.' +
                f.property +
                ').toLowerCase()' +
                f.opperand +
                ' "' +
                f.value +
                '".toLowerCase()' +
                ' && ';
              // filter vor Numbers
            } else if (
              f.opperand == '<' ||
              f.opperand == '<=' ||
              f.opperand == '>' ||
              f.opperand == '>='
            ) {
              filterString +=
                'e.' +
                f.property +
                ' ' +
                f.opperand +
                ' "' +
                f.value +
                '"' +
                ' && ';
            } else if (f.opperand == '!.includes(') {
              filterString +=
                '!String(e.' +
                f.property +
                ').toLowerCase()' +
                ".includes('" +
                f.value +
                "'.toLowerCase()) " +
                ' &&';
            } else {
              // Filter for includes
              filterString +=
                'String(e.' +
                f.property +
                ').toLowerCase()' +
                f.opperand +
                '"' +
                f.value +
                '".toLowerCase())' +
                ' &&';
            }
          }
          filterString = filterString.slice(0, filterString.length - 3);
          // eslint-disable-next-line no-unused-vars
          return filterItems.filter((e) => {
            if (!eval(filterString)) {
              this.removeSelectedFilteredItems(e.id);
              return false;
            } else return true;
          });
        } else return filterItems;
      }
    },
    unmatchingFrequenciesSelected() {
      let d = this.selectedSeries.some((e) => e.freq == 'D');
      let q = this.selectedSeries.some((e) => e.freq == '15T');
      let h = this.selectedSeries.some((e) => e.freq == 'H');
      return d && (q || h);
    },
    showLoadingSpinner() {
      let a = this.isLoading;
      let b = this.itemID != null;
      let c = this.isProfileDetailsVisible;
      return a || (b && !c);
    },
    getOperatorOption() {
      if (this.activeFilter && this.activeFilter.property) {
        return this.operatorOption.filter((operator) =>
          this.showFilterOperatorOption(
            operator.visibility,
            this.activeFilter.type
          )
        );
      }
      return [];
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    Chart,
    vueDropzone,
    ModalShare,
    ModalBox,
    hedgeParamsModal,
    forecastParamsModal,
    subtractParamsModal,
    mergeLoadsModal,
    sumParamsModal,
    ReportViewer,
    SlpProfile,
    Weather,
    ...components,
    LoadProfileDetails,
    LoadProfileSettings,
    htmlViewer,
    seriesComparator,
    changeUnitModal,
    GeneralDropdown,
  },
};
</script>

<style scoped>
.no-data .options {
  margin: 29px 130px;
  height: 296px;
  cursor: pointer;
}

.no-data .option h2 {
  font-size: 24px;
  color: #444f62;
  font-weight: 500;
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  text-transform: uppercase;
  margin-bottom: 14px;
}

.no-data .option .icon {
  margin-bottom: 23px;
  margin-top: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 66px;
}

.load-profile-list .no-data .option .icon {
  height: 60px;
}

.option.small img {
  height: 52px;
  margin-bottom: 8px;
  margin-top: 5px;
}

.no-data .option {
  width: 50%;
  display: inline-block;
  padding: 0 40px;
  height: 325px;
  text-align: center;
}

.left-option {
  border-right: 1px solid #d9dde2;
  float: left;
}
.left-option.single-option {
  border-right: none;
  float: none;
}

.no-data .slp {
  zoom: 1.1;
}
.modal-window {
  position: absolute;
  z-index: 16;
}

.load-profile-list {
  width: 100%;
  position: relative;

  /* i dont know why but height 100% doesnt work only min-height */
  min-height: 100%;
  height: fit-content;
  text-align: center;
  color: #5f697a;
  display: block;
  border-top: 1px solid rgb(231, 231, 232);
  background-color: #f9f9fb;
}

.dragNDropBackGround {
  cursor: pointer;
  background-image: url('../assets/img/drag-n-drop.png');
  background-size: 1100px 1118px;
  background-position: 50% 25px;
  background-repeat: no-repeat;
  overflow: hidden;
  width: 348px;
  display: inline-block;
  text-indent: -9999px;
  font-size: 0;
  line-height: 0;
  opacity: 0.95;
}

.customdropzone {
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizelegibility;
  width: 100%;
  transition: background-color 0.2s linear;
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  min-height: 400px;
  box-sizing: border-box;
  height: calc(82vh - 155px);
  /* scroll-padding-bottom: 110px;
  scroll-behavior: smooth; */
  overflow: auto;
  padding-left: 2px;
  padding-right: 2px;
  scrollbar-width: thin;
}

.customdropzone .dz-preview {
  display: inline-block;
  position: relative;
  width: 388px;
  height: 388px;
  margin: 0 30px 18px 0;
  border-radius: 4px;
  -webkit-box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05),
    0 1px 2px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  background: white;
  float: left;
}

.customdropzone .dz-preview.list {
  width: 100%;
  height: 45px;
  overflow: unset;
  z-index: 1;
  box-shadow: rgb(0 0 0 / 6%) 0px 3px 12px 0px, rgb(0 0 0 / 16%) 0px 1px 3px 0px;
  outline: none;
}

.customdropzone .dz-preview.list:hover {
  outline: none;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 4px 0px,
    rgb(0 0 0 / 14%) 0px 10px 16px 0px;
}

.customdropzone .dz-preview.checked.list:hover {
  box-shadow: 0 0 0 2px #1fc281;
}

.dz-message {
  color: #808ca7;
  margin-top: 35px;
}
.dz-message h2 {
  font-size: 43px;
  font-weight: 600;
  color: #808ba7;
  margin-top: 13px;
}
.dz-message p {
  font-size: 18px;
  font-weight: 100;
}
.dz-started .dz-message {
  display: none;
}

.customdropzone .dz-preview:hover {
  transform: translateY(-4px);
  box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.3), 0 0 1px 0 rgba(0, 0, 0, 0.2);
}

.customdropzone .dz-preview.loading:hover {
  transform: none;
  box-shadow: none;
}

.customdropzone .dz-preview.checked {
  transform: translateY(-4px);
  -webkit-box-shadow: 0 0 0 2px #1fc281;
  box-shadow: 0 0 0 2px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
}

.customdropzone .dz-preview.checked .dz-image .data-dz-thumbnail-bg-overlay {
  opacity: 1;
}

.customdropzone .dz-preview .dz-image {
  height: 224px;
  top: 0;
}

.customdropzone .dz-preview.dz-file-preview.list .dz-preview-wrapper .dz-image {
  height: 60px;
  width: 100%;
  position: absolute;
  z-index: 7;
  top: 0;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg {
  z-index: 1;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 224px;
  width: 388px;
  position: absolute;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg.loading {
  z-index: 4000;
  height: 100%;
  border-radius: 4px;
  opacity: 1;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.loading {
  opacity: 1;
}
.customdropzone
  .load-list
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay.loading {
  height: 60px;
}
.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay:hover {
  opacity: 1;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay {
  z-index: 5;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 224px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.85);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

.customdropzone .dz-preview.list .dz-image .data-dz-thumbnail-bg-overlay {
  height: 45px;
  display: block;
  position: unset;
  opacity: 1;
}
.customdropzone
  .dz-preview.list
  .dz-image
  .data-dz-thumbnail-bg-overlay.loading {
  height: 45px;
}

.customdropzone
  .dz-preview.list
  .dz-image
  .data-dz-thumbnail-bg-overlay
  .btn-oval {
  opacity: 1;
  display: inline-block;
  position: unset;
}

.customdropzone
  .dz-preview.list
  .dz-image
  .data-dz-thumbnail-bg-overlay
  .checker {
  display: inline-block;
  position: unset;
}

.customdropzone
  .dz-preview.list
  .dz-image
  .data-dz-thumbnail-bg-overlay
  .tools {
  display: inline-block;
  position: relative;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.loading {
  height: 388px;
  /* height: 100%; */
  border-radius: 4px;
  opacity: 1;
}

.data-dz-thumbnail-bg.processing {
  background-color: mediumslateblue;
}
.data-dz-thumbnail-bg.success {
  background-color: lightgreen;
}

.customdropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  background-size: contain;
}

.customdropzone .dz-preview .dz-image > img {
  width: 100%;
}

.customdropzone .dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}

.customdropzone .dz-preview .dz-progress {
  opacity: 1;
  height: 16px;
  width: 80px;
  background: hsla(0, 0%, 100%, 0.9);
  transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.customdropzone .dz-preview .dz-details {
  margin: 1px 18px 0;
  text-align: left;
}

.customdropzone .dz-preview .dz-details select {
  border: none;
  outline: none;
  background: white;
  color: #5f697a;
}

.customdropzone .list.dz-preview .dz-details {
  margin-top: 0;
  margin-left: 0;
  line-height: 45px;
  width: 100%;
  max-height: 45px;
  display: table;
  font-size: 13px;
}
.customdropzone .list.dz-preview .listview-dropdown-text {
  font-size: 12px;
  color: #47506e;
}
.customdropzone
  .list.dz-preview
  ::v-deep
  .filter-dropdown
  .dropdown-toggle::after {
  right: 30px !important;
}
.customdropzone .list.dz-preview .dz-details > div {
  position: relative;
  /* display: table-cell; */
  display: inline-flex;
  justify-content: center;
  width: 15%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 0;
}

.customdropzone .list.dz-preview .dz-details > .filename-rename-wrap {
  width: 26%;
  align-items: center;
}

.customdropzone .list.dz-preview .dz-details {
  color: #47506e;
  font-size: 12px;
}
.customdropzone .list.dz-preview .dz-details .checker {
  width: 4%;
  zoom: unset;
  padding-left: 15px;
}

.customdropzone .list.dz-preview .dz-details .dz-filename {
  max-width: 450px;
  width: 100%;
  margin-right: 5px;
}

.customdropzone .tools {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 2;
  border: 0px solid transparent;
  -webkit-transition: visibility 0s ease 450ms, -webkit-box-shadow 0.2s ease;
  -o-transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
}

.customdropzone .list .tools {
  right: unset;
  top: unset;
  width: auto;
  padding-left: 10px;
  padding-right: 10px;
  background-color: transparent;
  opacity: 0;
  margin-top: -2px;
  position: relative;
  margin-bottom: 0;
}

.customdropzone .list:hover .tools {
  background-color: white;
  opacity: 1;
}

.customdropzone .tools > li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0 6px;
  margin: 0;
}

.customdropzone .tools a {
  text-indent: -9999px;
}

.customdropzone a.btn-oval {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 166px;
  height: 36px;
  line-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  position: absolute;
  text-decoration: none;
}

.customdropzone a.btn-oval:hover {
  color: rgba(25, 29, 38, 0.85);
  background-color: white;
}

.customdropzone .list .btn-oval {
  /* top: 12px;
  left: 77%;
  right: 127px; */
  opacity: 0;
  transition: all 300ms ease-in-out;
  transform: translateX(-30%);
  position: relative;
}
.customdropzone .list:hover .btn-oval {
  opacity: 1;
  transform: translateX(0);
}
.customdropzone .list .btn-oval a {
  border: 1px solid #ccc;
  border-radius: 4px 4px 4px 4px;
  padding: 0 0;
  display: inline-block;
  cursor: pointer;
  font-size: 10px;
  font-weight: 400;
  text-transform: uppercase;
  line-height: 29px;
  text-decoration: none;
  height: 31px;
  width: 100px;
  text-align: center;
  margin: 0 15px;
}
.customdropzone .list .tools > li > a {
  zoom: unset;
}

.customdropzone .list:hover .tools {
  margin-top: 0px;
}

.customdropzone .btn-oval a:hover {
  color: rgba(25, 29, 38, 0.85);
  background-color: white;
}

.view-settings .zoom {
  width: 170px;
  position: unset;
  margin-left: 0;
  margin-top: 0;
  display: inline-block;
}

.view-settings .btn {
  width: 15px;
  height: 23px;
  padding: 0;
}

.view-settings .btn.active {
  background-color: #f0f0f0;
  border-radius: 3px;
}

.slider {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  height: 2px;
  position: relative;
  top: -4px;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}
.customdropzone .list .tools > li > a {
}
.customdropzone .tools > li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -868px -268px;
  width: 14px;
  height: 13px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.customdropzone .tools > li > a:hover {
  opacity: 1;
}

.customdropzone .list:hover .tools > li > a,
.customdropzone.list-view .tools .tool-icon:hover {
  filter: brightness(14%);
  opacity: 1 !important;
}

.customdropzone .tools li.share a {
  background-position: -868px -268px;
}

.customdropzone .tools li.duplicate a {
  background-position: -868px -457px;
}

.customdropzone .tools li.download a {
  background-position: -868px -646px;
}

.customdropzone .tools li.delete a {
  background-position: -129px -759px;
}

.customdropzone .tools li.dropdown a {
  background-position: -323px -754px;
  width: 22px;
}

ul li {
  line-height: 17px;
}

li {
  display: item;
  text-align: -webkit-match-parent;
}

input.dz-filename {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: text;
  width: 323px;
}

.dz-details input.disabled {
  background: white;
}

input:focus {
  outline-width: 0;
}

.customdropzone .dz-preview.dz-file-preview:hover input:not(.disabled) {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAUGVYSWZNTQAqAAAACAACARIAAwAAAAEAAQAAh2kABAAAAAEAAAAmAAAAAAADoAEAAwAAAAEAAQAAoAIABAAAAAEAAAAZoAMABAAAAAEAAAAZAAAAAEouuUAAAAFZaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA1LjQuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj4KICAgICAgICAgPHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CkzCJ1kAAAFgSURBVEgNxdQ9boMwFADgZxJHWbkCWzpkQZXaoVtzhFyhZ+kZuEKPkG4ZWiliydBKGThCmRPauH7As4wBFxxHtRThn/h99jOYgcey3e/DyYlvZMgoYLC6ixcphme+DA2I65g5QV6QDoDWXkIBtS558oJHcj7+zBKeBWwuQra7Q4S7wNxjaqSQm4psZ87p0lIEP7Ni9bBc5u/pZ4wrl4HDGktxzAnRADrkMpgBZYSPRjoAylADKniRIYqDoxAL0IKoA5+DD34AUMU9zuk8lDNVNUtlIFCna9F6w/5M1zigOgNzvVbEB4BgL+IL6EV8Ap2Ib6CFXANApPGdTI78WfbRVYHjZlFftTlga6uDr3fxZfmzE4Dx1E6C0/TpGkADYcD6EOcd0KLLnbztPh5lR0Sd6ikgoeta9TlUyrtLAFtrczMBIjnPvhO6qrUxp2p1QTJYg1w1A/Fyf3vz6hTpvyf9AjOC0J5+V6YFAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-position: 100% 49%;
  padding-right: 20px;
  background-size: 13px;
  min-height: 42px;
}

.customdropzone .dz-preview .dz-details input {
  font-size: 14px;
  line-height: 20px;
  display: table-cell;
  position: relative;
  padding: 0 0px;
  color: #47506e;
  font-weight: 400;
  margin: 0;
}

.customdropzone .dz-preview .dz-details input {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 98%;
  box-sizing: border-box;
  margin: 0 0px 0px;
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 13px;
}

.customdropzone .dz-preview .dz-details .dz-filename.rename:hover::after {
  overflow: hidden;
  display: block;
  width: 12px;
  height: 12px;
  top: 0;
  right: 0;
  position: absolute;
  content: '';
  margin: 4px 10px 0 0;
}

.customdropzone .dz-preview .dz-details .dz-filename.rename:disabled {
  background: white;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.checked {
  -webkit-box-shadow: 0 0 0 30px #1fc281;
  box-shadow: 0 0 0 30px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
  opacity: 1;
}

.customdropzone .dz-preview .dz-image div.checker {
  height: 20px;
  width: 20px;
  margin: 0;
  -webkit-transition: opacity 0.2s ease;
  -o-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
  opacity: 0.7;
  z-index: 1;
  display: block;
  position: absolute;
  top: 15px;
  left: 15px;
}

.customdropzone .dz-preview .dz-image div.checker:hover {
  opacity: 1;
}

.checker input,
.checker input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 21px;
  width: 20px;
  display: inline-block;
  background: 0 0;
  opacity: 0;
}

.list .checker input,
.list .checker input[type='checkbox'] {
  opacity: 1;
  accent-color: #53c08a;
  margin-right: 20px;
  margin-bottom: 3%;
  width: 17px;
}

.customdropzone .dz-preview .dz-image div.checker span {
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -488px -386px;
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
}

.customdropzone .list.dz-preview .dz-image div.checker span {
  filter: brightness(0.5);
}

.customdropzone .dz-preview.icon div.checker span.checked {
  background-position: -398px -283px;
  filter: none;
}

input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin: 0 0 9px;
  font-size: 100%;
  vertical-align: middle;
  display: inline-block;
}

.group-actions {
  display: block;
  background: #fff;
  position: fixed;
  bottom: 0;
  box-shadow: 0 -1px 0 rgba(76, 86, 103, 0.2),
    0 -2px 35px rgba(31, 37, 50, 0.14);
  z-index: 11;
  left: 0;
  width: 100%;
  height: 76px;
  padding: 10px 35px;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  text-align: center;
  float: left;
  clear: both;
}

.group-actions .inner {
  width: 100%;
  text-align: left;
  display: block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
}

.selected-items {
  font-size: 11px;
  border-radius: 100px;
  background: #54c08a;
  color: #fff;
  padding: 1px 14px 0px;
  margin: 1px 6px 0 0;
  float: left;
  font-weight: 600;
}
.selected-items-label {
  float: left;
  font-size: 12px;
  color: #4a556b;
  font-weight: 600;
  text-transform: uppercase;
  float: left;
  margin: 2px 0 0 10px;
  text-rendering: optimizelegibility;
}
.group-actions .toolbar {
  margin: 3.8px 0 0 -179px;
  position: absolute;
  left: 50%;
}
.toolbar .item {
  float: left;
  margin: 0 15px;
  list-style: none;
  padding: 0;
  display: item;
  text-align: -webkit-match-parent;
}

.toolbar .item .link {
  cursor: pointer;
  top: 50%;
  display: block;
  text-indent: -9999px;
  opacity: 0.9;
  background-size: 882px 840px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: block;
  overflow: hidden;
}

.toolbar .share .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: 0 -759px;
}

/*.toolbar .duplicate .link {  ( Style for Btn Duplicate for Toolbar when needed HTML is done too)
  background-image: url(../assets/img/project-sprite.png);
  background-position: -866px -329px;
}*/

.toolbar .delete .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -868px 0;
  width: 14px;
  height: 18px;
}

.toolbar .download .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -800px 0;
  width: 18px;
  height: 18px;
}
.toolbar .more {
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
}

.toolbar .more .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -463px -759px;
  width: 18px;
  height: 4px;
}

.dropdown {
  padding-left: 0px;
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
}

.dropdown-selection {
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 0px;
  list-style-type: none;
  border: 0;
  border-radius: 2px;
  -webkit-box-shadow: 0 2px 35px rgba(31, 37, 50, 0.14),
    0 0 0 1px rgba(76, 86, 103, 0.2);
  box-shadow: 0 2px 35px rgba(31, 37, 50, 0.14),
    0 0 0 1px rgba(76, 86, 103, 0.2);
  bottom: 10px;
  position: absolute;
  z-index: 100;
  min-width: 195px;
  list-style: none;
  background-color: #fff;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item {
  background: #fff;
  line-height: 36px;
  width: 100%;
  margin: 0;
  padding: 0 19px;
  margin-left: 7px;
  font-size: 14px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item.more {
  background-image: url(data:image/png;base64,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);
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
}

.toolbar .more .toggle-list-wrapper.toggle-up {
  margin-top: -100%;
  padding: 20px 0px 20px 0px;
  min-width: 195px;
  left: 0;
  top: 0;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item:hover {
  background-color: #f0f0f0;
}

.select-all-wrapper {
  float: right;
  margin-right: 100px;
  margin-top: -11px;
}
.btn-select-all {
  background-color: white;
  border-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  margin: 12.5px;
}
.btn-select-all:focus {
  outline: none;
}

.settings-button-wrapper {
  /* width: 200px; */
  display: block;
  margin-left: 0;
  top: unset;
  bottom: unset;
  position: relative;
  z-index: 6;
}

.view-settings .round-button {
  width: auto;
  height: auto;
  line-height: normal;
  box-shadow: none;
  background: transparent !important;
  top: unset;
  margin: 0 !important;
  padding: 0.375rem 0.75rem;
  box-sizing: border-box;
  display: inline-block;
  border-radius: 0;
}

.view-settings .settings-button-wrapper .round-button img {
  width: 20px;
}

.round-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 60px;
  line-height: 59px;
  font-size: 30px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  position: relative;
  transition: transform 0.2s ease-in-out;
}

.round-button-wrapper .round-button {
  position: absolute;
  right: 12%;
  top: -30.2px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.round-button.settings {
  background-color: white;
  color: clack;
  font-size: 19px;
  display: inline-block;
  margin-right: 7px;
}

.round-button.refresh {
  background-color: white;
  color: clack;
  font-size: 19px;
  display: inline-block;
  margin-right: 7px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}

.round-button img {
  width: 30px;
}

.round-button-wrapper.clicked .round-button {
  display: flex;
  justify-content: center;
  align-items: center;
  top: -30.2px;
  right: 12%;
}
.round-button-wrapper.clicked .round-button .plus {
  transform: rotate(45deg);
  left: 0.5px;
  top: 0.5px;
  position: relative;
}
.round-button:hover {
  transform: scale(1.1) rotate(0);
}
.round-button img:hover {
  transform: scale(1.1) rotate(0);
}

.round-button-wrapper.clicked .round-button:hover .plus {
  transform: scale(1.1) rotate(45deg);
  left: 0.4px;
  top: 0.3px;
  position: relative;
}
.round-button-wrapper.clicked .round-button:hover {
  display: flex;
  justify-content: center;
  align-items: center;
  top: -30.2px;
  right: 12%;
}

.plus-btn-options {
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  background-color: #ffff;
  position: absolute;
  right: 12%;
  z-index: 2;
}

.plus-btn-options .option {
  text-align: center;
  display: inline-block;
  padding: 47px 15px 45px;
  border-right: solid 1px #dbdee5;
  cursor: pointer;
  width: 200px;
}

.file-icon {
  background-image: url('../assets/img/slp-chart.png');
  background-size: 882px 840px;

  background-repeat: no-repeat;
  overflow: hidden;
  display: block;

  cursor: pointer;
  margin: 0 auto;
  height: 64px;
}

.plus-btn-options .option h2 {
  font: 600 15px/22px brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  color: #434c5e;
  text-transform: uppercase;
  margin-top: 14px;
  margin-bottom: 0px;
}

.option p {
  font-size: 13px;
  line-height: 22px;
  color: #596377;
  margin: 0;
  padding: 0;
  font-family: inherit;
  text-rendering: optimizelegibility;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  height: 24px;
}

.file {
  background-position: -712px 9px;
  width: 38px;
}

.slp {
  background-position: -662px -755px;
  width: 64px;
}

.accessibility {
  left: 64px;
  /*width: 20px !important;*/
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
}
.list .data-dz-thumbnail-bg-overlay .progress-icon {
  margin: 0 auto;
  right: 0;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 39px;
  width: 39px;
  position: absolute;
}

.list .data-dz-thumbnail-bg-overlay .progress-icon:after {
  height: 26px;
  width: 26px;
  margin-top: 0;
  box-sizing: border-box;
}

.icon.dz-preview.dz-file-preview .loading .progress-icon,
.icon.dz-preview.dz-file-preview .loading .progress-icon:after {
  width: 70px;
  height: 70px;
}

.h-full {
  box-sizing: border-box;
  min-height: calc(100vh - 80px);
  position: relative;
}
.progress-icon.dark-color {
  margin: auto;
}
.progress-icon.dark-color:after {
  border-color: #1f2532 transparent #1f2532 transparent;
  width: 100px;
  height: 100px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.dot-flashing {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #797f89;
  color: #c4c2cb;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #797f89;
  color: #c4c2cb;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #797f89;
  color: #c4c2cb;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: #797f89;
  }
  50%,
  100% {
    background-color: #c4c2cb;
  }
}

.status-icon {
  position: relative;
  left: 50%;
  top: 123px;
}

.customdropzone .list.dz-preview .dz-details .status-icon {
  top: 0px;
  left: 0px;
}

.customdropzone .list.dz-preview .dz-details .status-icon .dot-flashing {
  overflow: initial;
  min-width: unset;
  position: relative;
  left: 50px;
  top: -9px;
  padding-left: 0;
}

.data-dz-thumbnail-bg-overlay p {
  color: white;
  font-size: 14px;
  display: block;
  margin-top: 99px;
}

.status-img img {
  width: 88px;
  margin-top: 82px;
  opacity: 0.5;
}

.icon .status-img {
  display: flex;
  height: 100%;
}

.icon .status-img img {
  margin: auto;
}

.list .status-img img {
  width: 39px;
  margin-top: 0px;
  margin-left: 0;
}

input.rename::placeholder {
  color: #a0a4ad;
  font-style: inherit;
}

.show-on-hover {
  visibility: hidden;
  height: 0px;
  width: 0px;
  display: block;
}

.hide-on-hover {
  visibility: visible;
  height: 23px;
  width: fit-content;
  display: initial;
}

.customdropzone .dz-preview:hover .show-on-hover {
  visibility: visible;
  height: 23px;
  display: initial;
  height: auto;
  width: auto;
}

.customdropzone .dz-preview:hover .hide-on-hover {
  visibility: hidden;
  height: 0px;
}

.customdropzone .dz-preview .dz-details {
  font-size: 15px;
}

.customdropzone .list .dz-preview .dz-details {
  margin-top: -60px;
}

.file-filter {
  float: left;
  margin-left: 9%;
  width: fit-content;
}

.file-filter select {
  border: none;
  outline: none;
  background: white;
}

.menu3-bar {
  font-size: 12px;
  text-align: left;
}

.menu3-bar .item {
  margin: 0 46px 0 0;
  vertical-align: top;
  display: inline-block;
  line-height: 44px;
  cursor: pointer;
}

.menu3-bar .item.active {
  border-bottom: solid 2px rgb(255, 51, 102);
  color: rgb(247 58 105);
}

.list-item {
  padding-left: 0px;
  margin-bottom: 0;
}

::v-deep .menu3-bar .toggle-list-wrapper.toggle-down {
  position: absolute;
  left: 20px;
  top: 80px;
  width: 150px;
  z-index: 15;
  padding: 0;
  overflow: auto;
}

.menu3-bar .toggle-list-wrapper.toggle-down .item {
  margin: 0;
  padding-left: 25px;
  width: 100%;
}

::v-deep .menu3-bar .item.more .selected a {
  background: #f0f0f0 !important;
}

.menu3-bar .item.more .dropdown .link.dropdown-toggle {
  color: black;
}

.toggle-list-wrapper.toggle-up.toggle-right {
  position: absolute;
  left: 230px !important;
}

.search {
  width: fit-content;
  padding: 0;
  height: 31px;
  margin-left: 0px;
  margin-right: 0;
  margin-bottom: 0;
  height: 44px;
  cursor: auto;
}

.search.active {
  border-bottom: solid 2px rgb(255, 51, 102);
}

.search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  margin-top: 13px;
  cursor: pointer;
}

.search input {
  border: 0;
  width: 0;
  margin-left: 5px;
  cursor: initial;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
  height: 100%;
  background: transparent;
  padding: 0;
  transition: width 0.3s ease, border-color 0.3s ease;
}

.search.active input {
  width: 230px;
}

.customdropzone .white-space {
  width: 100%;
  height: 12px;
  display: grid;
}

.customdropzone .white-space.extra-height {
  width: 100%;
  height: 65px;
  display: grid;
}

.load-list {
  margin-top: 7px;
}

.load-list .white-space {
  height: 55px;
}

.header {
  display: table;
  background: #f9f9fb;
  height: 50px;
  width: 100%;
  font-size: 12px;
  padding: 0;
  box-sizing: border-box;
}
.header div {
  display: inline-flex;
  justify-content: center;
  line-height: 25px;
  padding: 15px 0px;
  color: #979799;
  font-weight: 500;
}

.header div.small {
  padding-left: 15px;
}

.customdropzone .dz-preview .dz-details > div {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.customdropzone .list.dz-preview .dz-details > div.listview-dropdown {
  overflow: unset;
  width: 10%;
}
.ellipsis-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  max-width: 265px;
}

.customdropzone .modal-open .dz-preview.list {
  z-index: unset !important;
}

.customdropzone .modal-open .dz-preview.list:hover {
  transform: unset !important;
}

.unit-wrap {
  cursor: pointer;
}

.edit-icon {
  margin: 0 0 0 5px !important;
  display: inline-flex !important;
  min-width: unset !important;
  max-width: unset !important;
  padding: 0 !important;
  width: 20px;
  height: 20px;
  align-items: center;
  line-height: 0;
  cursor: pointer;
  position: relative;
}

.edit-icon:after {
  background-image: url(/img/project-sprite.1c2e7465.png);
  background-size: 882px 840px;
  background-position: -728px -691px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  width: 100%;
  height: 100%;
  top: 6px;
  left: 0;
  position: absolute;
  content: '';
  margin: 0;
}

.menu3-bar {
  /* position: relative; */
  z-index: 9;
}

.filter-item-wrapper {
  min-width: 150px;
  position: relative;
  background: #f9f9fb;
  width: 100%;
  display: flex !important;
  flex-wrap: wrap;
}

.filter-item-wrapper .filter-item {
  margin-right: 10px;
  background: #fff;
  margin-bottom: 10px;
}

.filter-item-wrapper .filter.dropdown.edit {
  position: fixed;
  display: block;
  margin-top: 12px;
  margin-left: -16px;
  padding: 5px;
  display: flex;
  align-items: center;
}

.filter-item-wrapper .filter.dropdown.edit ::v-deep .dropdown .btn {
  width: fit-content;
}

.filter-item-wrapper .filter.dropdown.edit input {
  border: 1px solid #9398a3;
  margin-top: 0px !important;
  margin-left: 10px;
  margin-right: 10px;
  height: 26px;
}

.item.filter-option.show-option {
  padding-bottom: 40px;
}

.key-filter select:focus {
  outline-width: 0;
}

.key-filter input:focus {
  outline-width: 0;
}

.key-filter .filter .tools i {
  font-size: 15px !important;
}

.filter-icon {
  background-image: url('../assets/img/filter.svg');
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  margin-top: 13px;
  cursor: pointer;
}

.filter.dropdown select,
input {
  border: none;
  display: inline-block;
  height: 26px;
  width: 119px;
  color: #000;
  font-size: 14px;
  text-align: center;
}

.menu3-bar .filter.dropdown select,
.menu3-bar input {
  height: 36px;
  padding: 6px 12px;
}

.filter.dropdown.edit select,
input {
  display: block;
  border-radius: 3px;
  text-align: left;
}

.filter.dropdown.edit input {
  border: 1px solid #9398a3;
  margin-top: 10px;
  margin-left: 10px;
}

.filter.dropdown.add select,
input {
  display: inline-block;
}

.filter.dropdown.upload {
  width: 213px;
  padding: 39px;
  right: 43px;
  top: 195px;
  z-index: 3;
  cursor: pointer;
}

.filter-item-wrapper {
  margin-top: 8px;
  margin-bottom: 10px;
}

.filter-item {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  border: solid 1px #787d87;
  border-radius: 4px;
  padding: 6px 15px;
}

.filter-item i {
  opacity: 0;
  height: 5px;
  font-size: 11px;
  margin-left: 16px;
  color: #4f4f54;
}

.filter-item:hover {
  background-color: #f2f2f2;
}

.filter-item:hover i {
  opacity: 1;
}

.filter-item i.fa-caret-down {
  font-size: 15px;
  opacity: 1;
  width: 10px;
  margin-left: 16px;
}

.filter-item:hover i:hover {
  color: black;
}

.filter.dropdown {
  background-color: white;
  padding: 30px;
  -webkit-box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  border-radius: 9px;
  margin-top: 5px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  z-index: 6;
  margin-left: 0;
}

.filter.dropdown hr {
  margin-top: 3px;
  background-color: #f0ebeb;
}

.filter.dropdown h2 {
  font-weight: 300;
  font-size: 22px;
  margin-bottom: 26px;
}

.filter.dropdown select {
  background: white;
}

.create-new-action {
  padding-bottom: 10px;
  padding-top: 8px;
  border-top: 1px solid #eee;
  padding-left: 11px;
}

ul.item-hover li:hover {
  background: #f0f0f0;
}
.customdropzone .tools li i {
  color: #c3c4c7;
}
.create-new-action:hover {
  background: #f0f0f0;
}
.dz-preview-wrapper {
  position: relative;
}

.dropdown.action-dropdown {
  height: 100%;
}

.dropdown-open .dz-preview.dz-file-preview.list {
  z-index: unset !important;
  transform: none !important;
}

.dropdown.action-dropdown ul.item-hover.icon-view {
  /* height: 179px; */
  max-height: 179px;
}

.dropdown.action-dropdown ul.item-hover {
  position: absolute;
  right: 0;
  background: #fff;
  text-align: left;
  margin-right: 26px;
  z-index: 9;
  width: 255px;
  display: grid;
  list-style: none;
  max-height: 300px;
  overflow: auto;
  padding-left: 0;
  border: solid 0.1px #f0f0f0;
  border-radius: 4px;
  top: 37px;
}
.dz-file-preview.icon .dropdown.action-dropdown ul.item-hover {
  top: 40px;
}

.dropdown.action-dropdown ul.item-hover li {
  padding: 15px 25px;
  box-sizing: border-box;
  cursor: pointer;
}
.create-new-action i {
  margin-right: 10px;
}
.list-view.customdropzone .tools > li {
  padding: 0 0 0 11px;
}

.list-view .dropdown.action-dropdown ul.item-hover {
  width: 180px;
  top: 24px;
}

.list-view .dropdown.action-dropdown ul.item-hover li {
  padding: 10px 15px;
}
.customdropzone .dz-preview.icon div.checker span {
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -488px -386px;
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
  position: relative;
  top: 0;
  left: 0;
}

.data-dz-thumbnail-bg-overlay.loading .tools {
  display: none;
}

.icon-view.filter-space {
  padding-top: 50px;
}

.icon-view {
  padding-top: 6px;
  box-sizing: border-box;
  position: absolute;
  z-index: 2;
  height: calc(82vh - 110px);
  overflow: auto;
}

.loading {
  height: calc(100vh - 190px);
  background-color: #f9f9fb;
  position: static;
  width: 100%;
}

.loading .progress-icon,
.loading .progress-icon.dark-color {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
}

/* .customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay.deleteLoader {
  opacity: 1;
  height: 67%;
}

.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay.deleteLoader
  .tools,
.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay.deleteLoader
  .checker {
  display: none !important;
}

.dz-preview.dz-file-preview.icon.deleteLoader .progress-icon {
  opacity: 1;
  top: 33%;
}

.dz-preview.dz-file-preview.icon.deleteLoader {
  transform: none !important;
} */

.loading {
  background: transparent;
}

::v-deep
  .customdropzone.dragDropLoading
  .data-dz-thumbnail-bg-overlay.loading
  .progress-icon {
  left: 0;
}

/* .customdropzone .dz-preview.list:hover .dz-details > div:last-child {
  opacity: 0;
} */

.tools-oval-wrapper {
  position: absolute;
  right: 15px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 5;
  /* min-width: 200px; */
}
.load-profile-list .customdropzone .dz-preview.list:hover .tools-oval-wrapper {
  background: #fff;
}

.tools-oval-wrapper ul.tools {
  min-width: 140px;
  display: flex;
  justify-content: flex-end;
  padding-left: 0 !important;
}

.list-view.customdropzone .tools li:first-child {
  padding: 0;
}
.load-profile-list .go-to-top {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 12;
  font-size: 18px;
  border: none;
  outline: none;
  background-color: #1f2532;
  cursor: pointer;
  padding: 5px;
  width: 35px;
  height: 35px;
  border-radius: 50px;
  opacity: 0;
  transform: translateY(100px);
  animation-name: scrollButtonUp;
  animation-duration: 0.5s;
  animation-direction: alternate;
  animation-fill-mode: forwards;
  animation-delay: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.load-profile-list .go-to-top span {
  background-image: url(/img/project-sprite.1c2e7465.png);
  background-position: -1600px -1204px;
  width: 32px;
  height: 35px;
  display: block;
  background-repeat: no-repeat;
  overflow: hidden;
  zoom: 0.7;
  filter: brightness(100);
}
.list-view.customdropzone.customdropzone-spacing-to-top {
  padding-top: 28px;
}
@keyframes scrollButtonUp {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}

/*Action Topbar*/
.action-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.action-top-bar .view-settings {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.action-top-bar .list-view-icon {
  display: inline-block;
  padding: 6px 12px;
}

.action-top-bar .list-view-icon.active {
  background-color: #f0f0f0;
  border-radius: 3px;
  border: 1px solid #727c8c;
}

.is-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.action-top-bar .action-top-bar-left .clock-icon {
  width: 30px;
  height: 30px;
}
.higher-zIndex {
  z-index: 2 !important;
}
.toolbar ::v-deep .more-icon {
  width: 20px;
  opacity: 0.6;
}
.customdropzone.list-view .tools .tool-icon.more-icon {
  opacity: 0.6;
  width: 18px;
}
.customdropzone.list-view .tools .tool-icon {
  width: 13px;
  height: 13px;
}

::v-deep .customdropzone.dragNDropBackGround .dz-preview {
  background: rgba(25, 29, 38, 0.85);
  position: relative;
  width: 300px;
  height: 300px;
  display: block;
}

::v-deep .customdropzone.dragNDropBackGround .progress-icon:after {
  content: ' ';
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  -webkit-animation: progress-icon 1.2s linear infinite;
  animation: progress-icon 1.2s linear infinite;
  z-index: 9999;
  position: absolute;
  left: 0;
  right: 0;
}

::v-deep .customdropzone.dragNDropBackGround .dz-preview-wrapper {
  height: 100%;
}

::v-deep .customdropzone.dragNDropBackGround .dz-preview .dz-image {
  height: 100%;
}

::v-deep .customdropzone.dragNDropBackGround .dz-preview .dz-image .loading {
  position: relative;
  height: 300px;
}
.group-action-open {
  bottom: 60px !important;
}
.customdropzone .list.dz-preview ::v-deep .dropdown-toggle-icon {
  color: #47506e;
}
.list-view-btn-wrap .btn:focus-visible {
  border: none;
}
.customdropzone
  .list.dz-preview
  .dz-preview-wrapper
  .dz-details
  .filename-rename-wrap
  .filename-rename-badge {
  max-height: 20px;
  text-align: center;
  display: flex;
  align-items: center;
}

.load-profile-list
  .customdropzone
  .icon-view
  .dz-preview
  .dz-image
  .dropdown.action-dropdown
  ul
  .dropdown-action-item,
.load-profile-list
  .customdropzone
  .load-list
  .dz-preview
  .tools-oval-wrapper
  ul
  .dropdown-action-item {
  position: relative;
}

/*.load-profile-list .customdropzone .load-list .dz-preview .tools-oval-wrapper ul .dropdown-action-item */

.load-profile-list
  .customdropzone
  .icon-view
  .dz-preview
  .dz-image
  .dropdown.action-dropdown
  ul
  .loadingoverlay,
.load-profile-list
  .customdropzone
  .load-list
  .dz-preview
  .tools-oval-wrapper
  ul
  .loadingoverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f2532c7;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  text-align: center;
}

.load-profile-list
  .customdropzone
  .icon-view
  .dz-preview
  .dz-image
  .dropdown.action-dropdown
  ul
  .loadingoverlay
  .custom-table-progress-icon,
.load-profile-list
  .customdropzone
  .load-list
  .dz-preview
  .tools-oval-wrapper
  ul
  .loadingoverlay
  .custom-table-progress-icon {
  content: ' ';
  display: block;
  width: 30px;
  height: 30px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
  position: absolute;
  left: 45%;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.load-profile-list
  .customdropzone
  .icon-view
  .dz-preview
  .dz-image
  .dropdown.action-dropdown
  ul
  .loadingoverlay
  .custom-table-progress-icon {
  zoom: 1.3;
  border: 3px solid #fff;
  border-color: #fff transparent #fff transparent;
}
.load-profile-list .menu3-bar .filter.dropdown input[type='datetime-local'] {
  min-width: 185px;
}
.load-profile-list
  .filter-item-wrapper
  .filter.dropdown.edit
  input[type='datetime-local'] {
  min-width: 170px;
  padding: 0 5px;
}
</style>
